<template>
  <div>
    <div class="pa-0 ma-0">
      <div class="body-overall">
        <v-row style="padding-top:64px!important"></v-row>
        <div :class="getGextPanel" class="pt-6" style="margin:0px!important;">
          <div class="fonts-white container pl-0 pr-1">
            <div class="overlay-grey-web">

              <v-row v-if="tickets.length === 0" class="tickets-header">
                <div class="header-content">
                  <v-icon class="header-icon">mdi-ticket-confirmation</v-icon>
                  <h1 class="header-title">My Tickets</h1>
                  <span class="tickets-count">{{ tickets.length }} ticket{{ tickets.length !== 1 ? 's' : '' }}</span>
                </div>
              </v-row>

              <div v-if="tickets.length !== 0" class="tickets-header">
                <div class="header-content">
                  <v-icon class="header-icon">mdi-ticket-confirmation</v-icon>
                  <h1 class="header-title">My Tickets</h1>
                  <span class="tickets-count">{{ filteredTickets.length }} of {{ tickets.length }} ticket{{ tickets.length !== 1 ? 's' : '' }}</span>
                </div>
                
                <!-- Filters -->
                <div class="filters-section">
                  <v-btn-toggle
                    v-model="filterStatus"
                    mandatory
                    variant="outlined"
                    color="white"
                    class="filter-toggle"
                  >
                    <v-btn value="all" size="small">
                      <v-icon :left="!isMobile" size="small">mdi-ticket-outline</v-icon>
                      <span v-if="!isMobile">All</span>
                    </v-btn>
                    <v-btn value="active" size="small">
                      <v-icon :left="!isMobile" size="small">mdi-check-circle</v-icon>
                      <span v-if="!isMobile">Active</span>
                    </v-btn>
                    <v-btn value="used" size="small">
                      <v-icon :left="!isMobile" size="small">mdi-ticket-confirmation</v-icon>
                      <span v-if="!isMobile">Used</span>
                    </v-btn>
                    <v-btn value="nft" size="small">
                      <v-icon :left="!isMobile" size="small">mdi-ethereum</v-icon>
                      <span v-if="!isMobile">NFT</span>
                    </v-btn>
                    <v-btn value="cancelled" size="small">
                      <v-icon :left="!isMobile" size="small">mdi-cancel</v-icon>
                      <span v-if="!isMobile">Cancelled</span>
                    </v-btn>
                    <v-btn value="refunded" size="small">
                      <v-icon :left="!isMobile" size="small">mdi-cash-refund</v-icon>
                      <span v-if="!isMobile">Refunded</span>
                    </v-btn>
                    <v-btn value="non-nft" size="small">
                      <v-icon :left="!isMobile" size="small">mdi-ticket-account</v-icon>
                      <span v-if="!isMobile">Non-NFT</span>
                    </v-btn>
                  </v-btn-toggle>
                </div>

                <!-- Search Bar -->
                <div class="search-section">
                  <v-text-field
                    v-model="searchQuery"
                    placeholder="Search by event name, location, or organizer..."
                    prepend-inner-icon="mdi-magnify"
                    variant="outlined"
                    density="comfortable"
                    hide-details
                    clearable
                    class="search-field"
                  >
                    <template v-slot:append-inner>
                      <v-fade-transition>
                        <v-icon v-if="searchQuery && searchQuery.length > 0" size="small" color="success">
                          mdi-check
                        </v-icon>
                      </v-fade-transition>
                    </template>
                  </v-text-field>
                  <div v-if="searchQuery && filteredTickets.length > 0" class="search-results-info">
                    <v-icon size="16" color="primary">mdi-information</v-icon>
                    <span>Found {{ filteredTickets.length }} result{{ filteredTickets.length !== 1 ? 's' : '' }}</span>
                  </div>
                </div>



              </div>

              <!-- Empty State -->
              <v-row v-if="filteredTickets.length === 0" justify="center" align="center" class="empty-state">
                <v-col cols="12" class="text-center">
                  <div class="empty-icon-wrapper">
                    <v-icon size="80" color="grey">mdi-ticket-outline</v-icon>
                  </div>
                  <h2 class="empty-title">No Tickets Found</h2>
                  <p class="empty-subtitle">
                    {{ filterStatus === 'all' ? 'You don\'t have any tickets yet.' : `No ${filterStatus} tickets found.` }}
                  </p>
                  <v-btn
                    color="white"
                    variant="outlined"
                    class="mt-4"
                    @click="goToEvents"
                  >
                    <v-icon left>mdi-calendar-star</v-icon>
                    Browse Events
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Tickets Grid -->
              <div v-else-if="tickets.length !== 0" class="tickets-grid">
                <div
                  v-for="ticket in filteredTickets"
                  :key="ticket.id"
                  class="ticket-card"
                  :class="{ 
                    'ticket-nft': ticket.is_nft, 
                    'ticket-used': ticket.status === 'used' && isExpired(ticket),
                    'ticket-cancelled': ticket.status === 'cancelled',
                    'ticket-refunded': ticket.is_refunded
                  }"
                >
                  <!-- Card Header with Image -->
                  <div class="ticket-image-container" @click="showTicketDetails(ticket)">
                    <img :src="ticket.image_full === '' ? ticket.event_image : ticket.image_full" :alt="ticket.event_name" class="ticket-image">
                    <div class="ticket-overlay">
                      <div class="ticket-badges">
                        <span v-if="ticket.is_nft" class="badge badge-nft">
                          <v-icon size="14">mdi-ethereum</v-icon>
                          NFT
                        </span>
                        <span v-if="ticket.ticket_type" class="badge badge-type">
                          {{ ticket.ticket_type }}
                        </span>
                        <span v-if="ticket.status === 'cancelled'" class="badge badge-cancelled">
                          <v-icon size="14">mdi-cancel</v-icon>
                          Cancelled
                        </span>
                        <span v-else-if="ticket.is_refunded" class="badge badge-refunded">
                          <v-icon size="14">mdi-cash-refund</v-icon>
                          Refunded
                        </span>
                        <span v-else-if="ticket.refund_requested" class="badge badge-refund-pending">
                          <v-icon size="14">mdi-clock-alert</v-icon>
                          Refund Pending
                        </span>
                        <span v-else-if="ticket.refund_rejected" class="badge badge-refund-rejected">
                          <v-icon size="14">mdi-close-circle</v-icon>
                          Refund Rejected
                        </span>
                        <span v-else-if="ticket.is_used" class="badge badge-used">
                          <v-icon size="14">mdi-check</v-icon>
                          Used
                        </span>
                        <span v-else-if="isExpired(ticket)" class="badge badge-expired">
                          <v-icon size="14">mdi-alert</v-icon>
                          Expired
                        </span>
                        <span v-if="!isExpired(ticket)" class="badge badge-active">
                          <v-icon size="14">mdi-check-circle</v-icon>
                          Active
                        </span>
                        <span v-if="isNow(ticket)" class="badge badge-active">
                          <v-icon size="14">mdi-alert-circle-outline</v-icon>
                          LIVE NOW!
                        </span>
                        <span v-if="ticket.is_listed_for_sale" class="badge badge-for-sale">
                          <v-icon size="14">mdi-tag</v-icon>
                          For Sale
                        </span>
                      </div>
                      <v-btn
                        icon
                        size="small"
                        class="view-details-btn"
                        @click.stop="showTicketDetails(ticket)"
                      >
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                    </div>
                  </div>

                  <!-- Card Content -->
                  <div class="ticket-content">
                    <!-- Event Info -->
                    <div class="ticket-event-info">
                      <h3 class="event-name">{{ ticket.event_name }}</h3>
                      <p class="event-location">
                        <v-icon size="14" class="mr-1">mdi-map-marker</v-icon>
                        {{ ticket.event_location }}
                      </p>
                      <p class="event-organizer">
                        <v-icon size="14" class="mr-1">mdi-account-tie</v-icon>
                        {{ ticket.issuer_name }}
                        <v-icon v-if="ticket.issuer_verified" size="12" color="primary" class="ml-1">mdi-check-decagram</v-icon>
                      </p>
                    </div>

                    <!-- Owner Name (if non-transferable) -->
                    <div v-if="!ticket.is_transferable && (ticket.owner_name || ticket.owner_surname)" class="ticket-owner-info">
                      <v-icon size="14">mdi-account</v-icon>
                      <span class="owner-label">Ticket holder:</span>
                      <span class="owner-name">{{ ticket.owner_name }} {{ ticket.owner_surname }}</span>
                    </div>

                    <!-- Date & Time -->
                    <div class="ticket-datetime">
                      <div class="datetime-item">
                        <v-icon size="16">mdi-calendar</v-icon>
                        <span>{{ formatDate(ticket.event_date) }}{{ ticket.event_timezone ? ` (${ticket.event_timezone})` : '' }}</span>
                      </div>
                      <div class="datetime-item">
                        <v-icon size="16">mdi-clock-outline</v-icon>
                        <span>{{ ticket.event_time_start }}</span>
                      </div>
                    </div>

                    <!-- Seat Info (if applicable) -->
                    <div v-if="ticket.ticket_section || ticket.ticket_row || ticket.ticket_seat" class="ticket-seat-info">
                      <div v-if="ticket.ticket_section" class="seat-item">
                        <v-icon size="14">mdi-seat</v-icon>
                        <span>Section {{ ticket.ticket_section }}</span>
                      </div>
                      <div v-if="ticket.ticket_row" class="seat-item">
                        <span>Row {{ ticket.ticket_row }}</span>
                      </div>
                      <div v-if="ticket.ticket_seat" class="seat-item">
                        <span>Seat {{ ticket.ticket_seat }}</span>
                      </div>
                    </div>

                    <!-- Validation Info (if used) -->
                    <div v-if="ticket.is_used && ticket.validation_count > 0" class="ticket-validation-info">
                      <v-icon size="14" color="success">mdi-check-circle</v-icon>
                      <span class="validation-text">
                        Validated {{ ticket.validation_count }}x
                        <span v-if="ticket.used_date"> · {{ formatDateTime(ticket.used_date) }}</span>
                      </span>
                    </div>

                    <!-- Refund Requested Alert -->
                    <v-alert 
                      v-if="ticket.refund_requested && !ticket.is_refunded" 
                      type="warning" 
                      density="compact" 
                      class="mt-2 mb-2 refund-pending-alert"
                    >
                      <div class="refund-pending-info">
                        <v-icon size="16">mdi-clock-alert</v-icon>
                        <div class="refund-pending-content">
                          <span class="refund-pending-title">Refund Request Pending</span>
                          <p class="refund-pending-text">Your refund request is being processed.</p>
                        </div>
                      </div>
                    </v-alert>

                    <!-- Refund Rejected Alert -->
                    <v-alert 
                      v-if="ticket.refund_rejected" 
                      type="error" 
                      density="compact" 
                      class="mt-2 mb-2 refund-rejected-alert"
                    >
                      <div class="refund-rejected-info">
                        <v-icon size="16">mdi-close-circle</v-icon>
                        <div class="refund-rejected-content">
                          <span class="refund-rejected-title">Refund Request Rejected</span>
                          <p v-if="ticket.refund_rejected_reason" class="refund-rejected-reason">
                            {{ ticket.refund_rejected_reason }}
                          </p>
                          <p v-else class="refund-rejected-reason">
                            Your refund request was rejected. Please contact support for more information.
                          </p>
                        </div>
                      </div>
                    </v-alert>

                    <!-- Cancelled Info -->
                    <v-alert 
                      v-if="ticket.status === 'cancelled'" 
                      type="error" 
                      density="compact" 
                      class="mt-2 mb-2 cancelled-alert"
                    >
                      <div class="cancelled-info">
                        <v-icon size="16">mdi-cancel</v-icon>
                        <span>Cancelled</span>
                        <span v-if="ticket.cancelled_date" class="cancelled-date">
                          {{ formatDate(ticket.cancelled_date) }}
                        </span>
                      </div>
                      <p v-if="ticket.cancelled_reason" class="cancelled-reason">
                        {{ ticket.cancelled_reason }}
                      </p>
                    </v-alert>

                    <!-- Perks -->
                    <div v-if="ticket.perks && ticket.perks.length > 0" class="ticket-perks">
                      <div class="perks-label">
                        <v-icon size="14">mdi-star</v-icon>
                        <span>Perks Included</span>
                      </div>
                      <div class="perks-list">
                        <v-chip
                          v-for="perk in ticket.perks.slice(0, 2)"
                          :key="perk.perk_id"
                          size="x-small"
                          :color="perk.perk_used || isPerkExpired(perk) ? 'grey' : 'white'"
                          variant="outlined"
                          class="perk-chip"
                        >
                          {{ perk.perk_name }}
                        </v-chip>
                        <span v-if="ticket.perks.length > 2" class="more-perks">
                          +{{ ticket.perks.length - 2 }} more
                        </span>
                      </div>
                    </div>

                    <!-- Promo Track -->
                    <div v-if="ticket.promo_track_id && ticket.promo_track_playable" class="promo-track-section">
                      <v-btn
                        variant="outlined"
                        size="small"
                        class="promo-track-btn"
                        :disabled="!ticket.promo_track_unlocked"
                        @click.stop="playPromoTrack(ticket)"
                      >
                        <v-icon left size="18">mdi-play-circle</v-icon>
                        Play Promo Track
                      </v-btn>
                    </div>

                    <!-- Price -->
                    <div class="ticket-price">
                      <span class="price-label">Paid:</span>
                      <span class="price-value">{{ formatPrice(ticket) }}</span>
                    </div>

                    <v-divider class="my-3" style="opacity:0.2;"></v-divider>

                    <!-- Actions -->
                    <div class="ticket-actions">
                      <v-btn
                        variant="outlined"
                        size="small"
                        class="action-btn"
                        @click="showQRCode(ticket)"
                        :disabled="ticket.status === 'cancelled'"
                      >
                        <v-icon left size="18">mdi-qrcode</v-icon>
                        QR Code
                      </v-btn>

                      <v-btn
                        v-if="ticket.is_nft && ticket.is_resellable && !ticket.is_listed_for_sale"
                        variant="outlined"
                        size="small"
                        class="action-btn"
                        @click="sellTicket(ticket)"
                        :disabled="(ticket.status === 'cancelled' && !ticket.is_refunded) || (ticket.status === 'refunded' && !ticket.is_cancelled)"
                      >
                        <v-icon left size="18">mdi-currency-usd</v-icon>
                        Sell
                      </v-btn>

                      <v-btn
                        v-if="ticket.is_nft && ticket.is_transferable && !ticket.is_listed_for_sale"
                        variant="outlined"
                        size="small"
                        class="action-btn"
                        @click="transferTicket(ticket)"
                        :disabled="(ticket.status === 'cancelled' && !ticket.is_refunded) || (ticket.status === 'refunded' && !ticket.is_cancelled)"
                      >
                        <v-icon left size="18">mdi-send</v-icon>
                        Transfer
                      </v-btn>

                      <v-btn
                        v-if="ticket.status === 'cancelled' && !ticket.is_refunded"
                        variant="outlined"
                        size="small"
                        :disabled="ticket.refund_requested || ticket.refund_rejected || !canRequestRefund(ticket)"
                        class="action-btn"
                        :class="ticket.refund_requested ? 'action-btn-refund-pending' : 'action-btn-refund'"
                        @click="requestRefund(ticket)"
                      >
                        <v-icon left size="18">
                          {{ ticket.refund_requested ? 'mdi-clock-alert' : ticket.refund_rejected ? 'mdi-close-circle' : 'mdi-cash-refund' }}
                        </v-icon>
                        {{ ticket.refund_requested ? 'Pending' : ticket.refund_rejected ? 'Rejected' : 'Refund' }}
                      </v-btn>

                      <v-menu>
                        <template v-slot:activator="{ props }">
                          <v-btn
                            icon
                            size="small"
                            variant="text"
                            v-bind="props"
                          >
                            <v-icon>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <v-list class="ticket-menu">
                          <v-list-item @click="showTicketDetails(ticket)">
                            <template v-slot:prepend>
                              <v-icon>mdi-information</v-icon>
                            </template>
                            <v-list-item-title>Details</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="downloadTicket(ticket)">
                            <template v-slot:prepend>
                              <v-icon>mdi-download</v-icon>
                            </template>
                            <v-list-item-title>Download</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="shareTicket(ticket)">
                            <template v-slot:prepend>
                              <v-icon>mdi-share-variant</v-icon>
                            </template>
                            <v-list-item-title>Share</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="ticket.event_location_map_link" @click="openMap(ticket)">
                            <template v-slot:prepend>
                              <v-icon>mdi-map</v-icon>
                            </template>
                            <v-list-item-title>View on Map</v-list-item-title>
                          </v-list-item>
                          <v-divider v-if="canRefund(ticket)"></v-divider>
                          <v-list-item v-if="canRefund(ticket)" @click="refundTicket(ticket)">
                            <template v-slot:prepend>
                              <v-icon color="error">mdi-cash-refund</v-icon>
                            </template>
                            <v-list-item-title>Request Refund</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </div>
                </div>
              </div>

                    <div v-if="showLoadMoreButton" class="load-older-section">
                      
                      <div class="load-older-info">
                        <v-icon size="20" color="grey">mdi-calendar-clock</v-icon>
                        <span class="oldest-date-text">
                          Showing tickets up to {{ oldestTicketDate }}
                        </span>
                      </div>

                      <v-btn
                        variant="outlined"
                        size="large"
                        class="load-older-btn"
                        @click="loadOlderTickets"
                        :loading="loadingMore"
                        :disabled="loadingMore || allTicketsLoaded"
                        block
                      >
                        <v-icon left class="pr-2">mdi-arrow-down-circle</v-icon>
                        <span v-if="!loadingMore">Load Older Tickets</span>
                        <span v-else>Loading...</span>
                        <v-icon right class="pl-2">mdi-history</v-icon>
                      </v-btn>

                      <div class="pagination-info-footer">
                        <span class="info-text">
                          <v-icon size="14">mdi-ticket-outline</v-icon>
                          {{ tickets.length }} of {{ totalTickets }} tickets loaded
                        </span>
                        <span class="info-text">
                          <v-icon size="14">mdi-file-document-outline</v-icon>
                          Page {{ currentPage }} of {{ totalPages }}
                        </span>
                      </div>
                    </div>
                    <div v-if="allTicketsLoaded && tickets.length > 0" class="all-loaded-section">
                      <div class="all-loaded-message">
                        <v-icon size="32" color="success">mdi-check-circle</v-icon>
                        <h3>All tickets loaded</h3>
                        <p>You've reached the end of your ticket history</p>
                        <v-btn
                          variant="outlined"
                          size="small"
                          @click="refreshTickets"
                          class="mt-4"
                        >
                          <v-icon left>mdi-refresh</v-icon>
                          Refresh
                        </v-btn>
                      </div>
                    </div>

            </div>
          </div>
        </div>
        <v-row :style="(this.isMobileXs || this.isMobilePlayer3) ? 'padding-top:170px!important':'padding-top:123px!important'"></v-row>
      </div>
    </div>

    <!-- QR Code Dialog -->
    <v-dialog v-model="showQRDialog" max-width="500">
      <v-card class="qr-dialog">
        <v-card-title class="qr-dialog-header">
          <span>{{ selectedTicket?.event_name }}</span>
          <v-btn icon @click="showQRDialog = false" variant="text">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="qr-dialog-content">
          <div class="qr-code-container">
            <div class="qr-placeholder">

                        <v-card class="qr-code-card">
                              <QRCodeVue3
                                :width="300"
                                :height="300"
                                :value="selectedTicket?.qr_code"
                                :qrOptions="{ typeNumber: 0, mode: 'Byte', errorCorrectionLevel: 'H' }"
                                :imageOptions="{ hideBackgroundDots: true, imageSize: 1, margin: 0 }"
                                :dotsOptions="{
                                  type: 'dots',
                                  color: '#f01ff0',
                                  gradient: {
                                    type: 'linear',
                                    rotation: 0,
                                    colorStops: [
                                      { offset: 0, color: '#f01ff0' },
                                      { offset: 1, color: '#1ff050' },
                                    ],
                                  },
                                }"
                                :backgroundOptions="{ color: '#000000' }"
                                :cornersSquareOptions="{ type: 'dot', color: '#ffffff' }"
                                :cornersDotOptions="{ type: undefined, color: '#ffffff' }"
                                fileExt="png"
                              />
                          </v-card>
              <p class="qr-code-text">{{ selectedTicket?.qr_code }}</p>
            </div>
          </div>
          <div class="qr-info">
            <div class="qr-info-item">
              <v-icon size="16">mdi-ticket</v-icon>
              <span>{{ selectedTicket?.ticket_number }}</span>
            </div>
            <div class="qr-info-item">
              <v-icon size="16">mdi-calendar</v-icon>
              <span>{{ formatDate(selectedTicket?.event_date) }}</span>
            </div>
            <div class="qr-info-item">
              <v-icon size="16">mdi-clock</v-icon>
              <span>{{ selectedTicket?.event_time_start }}</span>
            </div>
          </div>
          <v-alert v-if="selectedTicket?.is_used" type="warning" class="mt-4">
            <div class="alert-content">
              <v-icon left>mdi-alert</v-icon>
              <div>
                <div class="alert-title">This ticket has been validated</div>
                <div class="alert-details">
                  <span v-if="selectedTicket?.validation_count">
                    Used {{ selectedTicket.validation_count }} time{{ selectedTicket.validation_count > 1 ? 's' : '' }}
                  </span>
                  <span v-if="selectedTicket?.used_date">
                    · Last: {{ formatDateTime(selectedTicket.used_date) }}
                  </span>
                </div>
              </div>
            </div>
          </v-alert>
        </v-card-text>
        <v-card-actions class="qr-dialog-actions">
          <v-btn 
            v-if="isMobile && isIOS" 
            variant="outlined" 
            @click="addToAppleWallet"
          >
            <v-icon left>mdi-wallet</v-icon>
            Add to Wallet
          </v-btn>
          <v-btn 
            v-else-if="isMobile && isAndroid" 
            variant="outlined" 
            @click="addToGoogleWallet"
          >
            <v-icon left>mdi-google</v-icon>
            Add to Google Wallet
          </v-btn>
          <v-btn variant="outlined" @click="downloadQR">
            <v-icon left>mdi-download</v-icon>
            Download QR
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="showQRDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Ticket Details Dialog -->
    <v-dialog v-model="showDetailsDialog" max-width="800" scrollable>
      <v-card class="details-dialog">
        <v-card-title class="details-dialog-header">
          <div class="details-header-content">
            <div>
              <h2>{{ selectedTicket?.event_name }}</h2>
              <p class="ticket-number">Ticket #{{ selectedTicket?.ticket_number }}</p>
            </div>
            <v-btn icon @click="showDetailsDialog = false" variant="text">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text class="details-dialog-content">
          <!-- Event Information -->
          <div class="details-section">
            <h3 class="section-title">
              <v-icon left>mdi-calendar-star</v-icon>
              Event Information
            </h3>
            <div class="info-grid">
              <div class="info-item">
                <span class="info-label">Event Name:</span>
                <span class="info-value">{{ selectedTicket?.event_name }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Date:</span>
                        <span class="info-value">{{ formatDate(selectedTicket?.event_date) }}{{ selectedTicket?.event_timezone ? ` (${selectedTicket.event_timezone})` : '' }}</span>
                        </div>
                        <div class="info-item">
                        <span class="info-label">Date:</span>
                <span class="info-value">{{ formatDate(selectedTicket?.event_date) }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Start time - End Time:</span>
                <span class="info-value">{{ selectedTicket?.event_time_start }} - {{ selectedTicket?.event_time_end }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Location:</span>
                <span class="info-value">{{ selectedTicket?.event_location }}</span>
              </div>
              <div class="info-item full-width">
                <span class="info-label">Address:</span>
                <span class="info-value">{{ selectedTicket?.event_location_address }}</span>
              </div>
              <div v-if="selectedTicket?.event_description" class="info-item full-width">
                <span class="info-label">Description:</span>
                <span class="info-value">{{ selectedTicket?.event_description }}</span>
              </div>
                <div v-if="selectedTicket?.language && selectedTicket.language.length > 0" class="info-item">
                <span class="info-label">
                  <v-icon size="14">mdi-translate</v-icon>
                  {{ selectedTicket.language && selectedTicket.language.length > 1 ? 'Languages:' : 'Language:' }}
                </span>
                <span class="info-value">
                  <span class="language-display">
                    <span class="flag-emoji">{{ getLanguageFlag(selectedTicket.language) }}</span>
                  </span>
                </span>
                </div>
            </div>
          </div>

          <v-divider class="my-4"></v-divider>

          <!-- Organizer Information -->
          <div class="details-section">
            <h3 class="section-title">
              <v-icon left>mdi-account-tie</v-icon>
              Organizer Information
            </h3>
            <div class="info-grid">
              <div class="info-item">
                <span class="info-label">Organizer:</span>
                <span class="info-value">
                  {{ selectedTicket?.issuer_name }}
                  <v-icon v-if="selectedTicket?.issuer_verified" size="14" color="primary" class="ml-1">mdi-check-decagram</v-icon>
                </span>
              </div>
              <div class="info-item">
                <span class="info-label">Contact:</span>
                <span class="info-value">{{ selectedTicket?.issuer_email }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Issue Date:</span>
                <span class="info-value">{{ formatDateTime(selectedTicket?.issue_date) }}</span>
              </div>
            </div>
          </div>

          <v-divider class="my-4"></v-divider>

          <!-- Ticket Details -->
          <div class="details-section">
            <h3 class="section-title">
              <v-icon left>mdi-ticket</v-icon>
              Ticket Details
            </h3>
            <div class="info-grid">
              <div class="info-item">
                <span class="info-label">Type:</span>
                <span class="info-value">{{ selectedTicket?.ticket_type }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Category:</span>
                <span class="info-value">{{ selectedTicket?.ticket_category }}</span>
              </div>
              <div v-if="selectedTicket?.ticket_section" class="info-item">
                <span class="info-label">Section:</span>
                <span class="info-value">{{ selectedTicket?.ticket_section }}</span>
              </div>
              <div v-if="selectedTicket?.ticket_row" class="info-item">
                <span class="info-label">Row:</span>
                <span class="info-value">{{ selectedTicket?.ticket_row }}</span>
              </div>
              <div v-if="selectedTicket?.ticket_seat" class="info-item">
                <span class="info-label">Seat:</span>
                <span class="info-value">{{ selectedTicket?.ticket_seat }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Status:</span>
                <span class="info-value">
                  <v-chip size="small" :color="getStatusColor(selectedTicket, selectedTicket?.status)">
                    {{ selectedTicket?.status === 'active' && isExpired(selectedTicket) ? 'expired' : selectedTicket?.status }}
                  </v-chip>
                </span>
              </div>
              <div v-if="!selectedTicket?.is_transferable && (selectedTicket?.owner_name || selectedTicket?.owner_surname)" class="info-item full-width">
                <span class="info-label">Ticket Holder:</span>
                <span class="info-value">{{ selectedTicket?.owner_name }} {{ selectedTicket?.owner_surname }}</span>
              </div>
              <div v-if="selectedTicket?.ticket_description" class="info-item full-width">
                <span class="info-label">Description:</span>
                <span class="info-value">{{ selectedTicket?.ticket_description }}</span>
              </div>
              <div v-if="selectedTicket?.privacy_url || selectedTicket?.terms_url" class="info-item full-width">
                <span class="info-label">Legal:</span>
                <span class="info-value">
                  <a v-if="selectedTicket?.privacy_url" 
                     :href="selectedTicket.privacy_url" 
                     target="_blank" 
                     class="legal-link">
                    Privacy Policy
                  </a>
                  <span v-if="selectedTicket?.privacy_url && selectedTicket?.terms_url"> · </span>
                  <a v-if="selectedTicket?.terms_url" 
                     :href="selectedTicket.terms_url" 
                     target="_blank" 
                     class="legal-link">
                    Terms & Conditions
                  </a>
                </span>
              </div>
            </div>
          </div>

          <v-divider v-if="selectedTicket?.is_used" class="my-4"></v-divider>

          <!-- Validation History -->
          <div v-if="selectedTicket?.is_used && selectedTicket?.validation_history?.length > 0" class="details-section">
            <h3 class="section-title">
              <v-icon left>mdi-check-circle</v-icon>
              Validation History
            </h3>
            <div class="validation-history">
              <div class="validation-summary">
                <v-icon color="success">mdi-ticket-confirmation</v-icon>
                <span>Validated {{ selectedTicket.validation_count }} time{{ selectedTicket.validation_count > 1 ? 's' : '' }}</span>
                <span v-if="selectedTicket.validation_max > 1" class="validation-max">
                  (Max: {{ selectedTicket.validation_max }})
                </span>
              </div>
              <div class="validation-list">
                <div v-for="(validation, index) in selectedTicket.validation_history" :key="index" class="validation-item">
                  <div class="validation-header">
                    <v-icon size="16" color="success">mdi-check-circle-outline</v-icon>
                    <span class="validation-number">Check #{{ index + 1 }}</span>
                    <v-chip size="x-small" variant="outlined">{{ validation.validation_type }}</v-chip>
                  </div>
                  <div class="validation-details">
                    <div class="validation-detail-item">
                      <v-icon size="12">mdi-clock-outline</v-icon>
                      <span>{{ formatDateTime(validation.validated_date) }}</span>
                    </div>
                    <div v-if="validation.validated_location" class="validation-detail-item">
                      <v-icon size="12">mdi-map-marker</v-icon>
                      <span>{{ validation.validated_location }}</span>
                    </div>
                    <div v-if="validation.validated_by" class="validation-detail-item">
                      <v-icon size="12">mdi-account</v-icon>
                      <span>Validated by: {{ validation.validated_by }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <v-divider v-if="selectedTicket?.refund_requested || selectedTicket?.refund_rejected" class="my-4"></v-divider>

          <!-- Refund Status Information -->
          <div v-if="selectedTicket?.refund_requested || selectedTicket?.refund_rejected" class="details-section">
            <h3 class="section-title">
              <v-icon left :color="selectedTicket?.refund_rejected ? 'error' : 'warning'">
                {{ selectedTicket?.refund_rejected ? 'mdi-close-circle' : 'mdi-clock-alert' }}
              </v-icon>
              Refund Status
            </h3>
            
            <!-- Refund Requested -->
            <v-alert v-if="selectedTicket?.refund_requested && !selectedTicket?.is_refunded" type="warning" class="refund-status-alert">
              <div class="refund-status-content">
                <div class="refund-status-header">
                  <v-icon left>mdi-clock-alert</v-icon>
                  <span class="refund-status-title">Refund Request Pending</span>
                </div>
                <p class="refund-status-text">
                  Your refund request has been submitted and is currently being reviewed by the event organizer.
                </p>
                <div class="refund-status-timeline">
                  <div class="timeline-item completed">
                    <v-icon size="16" color="success">mdi-check-circle</v-icon>
                    <span>Request Submitted</span>
                  </div>
                  <div class="timeline-item active">
                    <v-icon size="16" color="warning">mdi-clock-outline</v-icon>
                    <span>Under Review</span>
                  </div>
                  <div class="timeline-item">
                    <v-icon size="16">mdi-circle-outline</v-icon>
                    <span>Refund Processed</span>
                  </div>
                </div>
                <p class="refund-status-note">
                  <v-icon size="14">mdi-information</v-icon>
                  You will be notified via email once your request is processed.
                </p>
              </div>
            </v-alert>

            <!-- Refund Rejected -->
            <v-alert v-if="selectedTicket?.refund_rejected" type="error" class="refund-status-alert">
              <div class="refund-status-content">
                <div class="refund-status-header">
                  <v-icon left>mdi-close-circle</v-icon>
                  <span class="refund-status-title">Refund Request Rejected</span>
                </div>
                <p class="refund-status-text">
                  Unfortunately, your refund request was not approved.
                </p>
                <div v-if="selectedTicket?.refund_rejected_reason" class="refund-rejected-reason-box">
                  <strong>Reason:</strong>
                  <p>{{ selectedTicket.refund_rejected_reason }}</p>
                </div>
                <p v-else class="refund-status-text">
                  No specific reason was provided. Please contact the event organizer for more information.
                </p>
                <div class="refund-contact-support">
                  <v-btn variant="outlined" size="small" @click="contactSupport()">
                    <v-icon left>mdi-email</v-icon>
                    Contact Support
                  </v-btn>
                </div>
              </div>
            </v-alert>
          </div>

          <v-divider v-if="selectedTicket?.status === 'cancelled' || selectedTicket?.status === 'refunded'" class="my-4"></v-divider>

          <!-- Cancellation Info -->
          <div v-if="selectedTicket?.status === 'cancelled' || selectedTicket?.status === 'refunded'" class="details-section">
            <h3 class="section-title">
              <v-icon left color="error">mdi-cancel</v-icon>
              Cancellation Information
            </h3>
            <v-alert type="error" class="cancellation-alert">
              <div class="info-grid">
                <div v-if="selectedTicket?.cancelled_date" class="info-item">
                  <span class="info-label">Cancelled Date:</span>
                  <span class="info-value">{{ formatDateTime(selectedTicket?.cancelled_date) }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">Status:</span>
                  <span class="info-value">
                    <v-chip v-if="selectedTicket?.is_refunded" size="small" color="warning">Refunded</v-chip>
                    <v-chip v-else size="small" color="error">Not Refunded</v-chip>
                  </span>
                </div>
                <div v-if="selectedTicket?.cancelled_reason" class="info-item full-width">
                  <span class="info-label">Reason:</span>
                  <span class="info-value">{{ selectedTicket?.cancelled_reason }}</span>
                </div>
                <div v-if="selectedTicket?.is_refunded" class="info-item">
                  <span class="info-label">Refund Date:</span>
                  <span class="info-value">{{ formatDateTime(selectedTicket?.refund_date) }}</span>
                </div>
                <div v-if="selectedTicket?.is_refunded && selectedTicket?.refund_amount" class="info-item">
                  <span class="info-label">Refund Amount:</span>
                  <span class="info-value">${{ selectedTicket?.refund_amount }}</span>
                </div>
              </div>
            </v-alert>
          </div>

          <v-divider v-if="selectedTicket?.is_transferable && selectedTicket?.owner_history?.length > 1" class="my-4"></v-divider>

          <!-- Transfer History -->
          <div v-if="selectedTicket?.is_transferable && selectedTicket?.owner_history?.length > 1" class="details-section">
            <h3 class="section-title">
              <v-icon left>mdi-swap-horizontal</v-icon>
              Transfer History
            </h3>
            <div class="transfer-info">
              <div class="transfer-summary">
                <v-icon>mdi-transfer</v-icon>
                <span>Transferred {{ selectedTicket.owner_history.length - 1 }} time{{ selectedTicket.owner_history.length > 2 ? 's' : '' }}</span>
                <span v-if="selectedTicket.transfer_max > -1" class="transfer-max">
                  ({{ selectedTicket.transfer_count }}/{{ selectedTicket.transfer_max }} transfers used)
                </span>
              </div>
              <div class="transfer-list">
                <div v-for="(owner, index) in selectedTicket.owner_history" :key="index" class="transfer-item">
                  <div class="transfer-icon-wrapper">
                    <v-icon v-if="index === 0" size="20" color="primary">mdi-account-star</v-icon>
                    <v-icon v-else size="20">mdi-account-arrow-right</v-icon>
                    <div v-if="index < selectedTicket.owner_history.length - 1" class="transfer-line"></div>
                  </div>
                  <div class="transfer-details">
                    <div class="transfer-header">
                      <span class="transfer-label">
                        {{ index === 0 ? 'Original Owner' : index === selectedTicket.owner_history.length - 1 ? 'Current Owner' : `Owner #${index + 1}` }}
                      </span>
                      <v-chip size="x-small" variant="outlined">{{ owner.acquired_method }}</v-chip>
                    </div>
                    <div class="transfer-info-grid">
                      <div class="transfer-detail-item">
                        <v-icon size="12">{{ owner.owner_verse_username && owner.owner_verse_username !== '' ? 'mdi-account' : 'mdi-email' }}</v-icon>
                        <span>{{ owner.owner_verse_username && owner.owner_verse_username !== '' ? owner.owner_verse_username : owner.owner_email }}</span>
                      </div>
                      <div class="transfer-detail-item">
                        <v-icon size="12">mdi-calendar</v-icon>
                        <span>{{ formatDateTime(owner.acquired_date) }}</span>
                      </div>
                      <div v-if="owner.acquired_price_usd > 0 || owner.acquired_price_muz > 0 || owner.acquired_price_eur > 0 || owner.acquired_price_pln > 0 || owner.acquired_price_btc > 0 || owner.acquired_price_eth > 0" class="transfer-detail-item">
                        <v-icon size="12">mdi-cash</v-icon>
                        <span v-if="owner.acquired_price_usd > 0">${{ owner.acquired_price_usd }}</span>
                        <span v-else-if="owner.acquired_price_muz > 0">{{ owner.acquired_price_muz }} MUZ</span>
                        <span v-else-if="owner.acquired_price_eur > 0">€{{ owner.acquired_price_eur }}</span>
                        <span v-else-if="owner.acquired_price_pln > 0">zł{{ owner.acquired_price_pln }}</span>
                        <span v-else-if="owner.acquired_price_btc > 0">₿{{ owner.acquired_price_btc }}</span>
                        <span v-else-if="owner.acquired_price_eth > 0">Ξ{{ owner.acquired_price_eth }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <v-divider v-if="selectedTicket?.perks && selectedTicket.perks.length > 0" class="my-4"></v-divider>

          <!-- Perks -->
          <div v-if="selectedTicket?.perks && selectedTicket.perks.length > 0" class="details-section">
            <h3 class="section-title">
              <v-icon left>mdi-star</v-icon>
              Included Perks
            </h3>
            <div class="perks-detailed-list">
              <div v-for="perk in selectedTicket.perks" :key="perk.perk_id" class="perk-detailed-item">
                <div class="perk-header">
                  <v-icon :color="perk.perk_used ? 'grey' : 'white'">
                    {{ perk.perk_used ? 'mdi-check-circle' : 'mdi-star-circle' }}
                  </v-icon>
                  <span class="perk-name">{{ perk.perk_name }}</span>
                  <v-chip v-if="perk.perk_used" size="x-small" color="grey">Used</v-chip>
                  <v-chip v-else-if="isPerkExpired(perk)" size="x-small" color="error" variant="outlined">Expired</v-chip>
                  <v-chip v-else size="x-small" color="success" variant="outlined">Available</v-chip>
                </div>
                <p class="perk-description">{{ perk.perk_description }}</p>
                <div v-if="perk.perk_quantity" class="perk-quantity">
                  <v-icon size="12">mdi-numeric</v-icon>
                  <span>{{ perk.perk_quantity_used || 0 }}/{{ perk.perk_quantity }} used</span>
                </div>
                <div v-if="perk.perk_valid_from" class="perk-validity">
                  <v-icon size="12">mdi-clock-outline</v-icon>
                  <span>Valid: {{ formatDateTime(perk.perk_valid_from) }} - {{ formatDateTime(perk.perk_valid_until) }}</span>
                </div>
                <div v-if="perk.perk_used && perk.perk_used_date" class="perk-used-date">
                  <v-icon size="12">mdi-check</v-icon>
                  <span>Used on: {{ formatDateTime(perk.perk_used_date) }}</span>
                </div>
              </div>
            </div>
          </div>

          <v-divider v-if="selectedTicket?.is_nft" class="my-4"></v-divider>

          <!-- NFT Information -->
          <div v-if="selectedTicket?.is_nft" class="details-section">
            <h3 class="section-title">
              <v-icon left>mdi-ethereum</v-icon>
              NFT Information
            </h3>
            <div class="info-grid">
              <!--div class="info-item">
                <span class="info-label">Blockchain:</span>
                <span class="info-value">{{ selectedTicket?.blockchain_chain }}</span>
              </div>
              <div-- class="info-item">
                <span class="info-label">Token ID:</span>
                <span class="info-value">{{ selectedTicket?.blockchain_token_id }}</span>
              </div-->
              <div class="info-item">
                <span class="info-label">Transferable:</span>
                <span class="info-value">
                  <v-chip size="small" :color="selectedTicket?.is_transferable ? 'success' : 'grey'">
                    {{ selectedTicket?.is_transferable ? 'Yes' : 'No' }}
                  </v-chip>
                </span>
              </div>
              <div class="info-item">
                <span class="info-label">Resellable:</span>
                <span class="info-value">
                  <v-chip size="small" :color="selectedTicket?.is_resellable ? 'success' : 'grey'">
                    {{ selectedTicket?.is_resellable ? 'Yes' : 'No' }}
                  </v-chip>
                </span>
              </div>
              <div v-if="selectedTicket?.resale_royalty_percent && selectedTicket?.is_resellable" class="info-item">
                <span class="info-label">Resale Royalty:</span>
                <span class="info-value">{{ selectedTicket?.resale_royalty_percent }}%</span>
              </div>
              <!--div class="info-item full-width">
                <span class="info-label">Contract:</span>
                <span class="info-value monospace">{{ selectedTicket?.blockchain_contract }}</span>
              </div>
              <div class="info-item full-width">
                <span class="info-label">Transaction:</span>
                <span class="info-value monospace">{{ selectedTicket?.blockchain_tx_hash }}</span>
              </div>
              <div-- v-if="selectedTicket?.blockchain_owner_address" class="info-item full-width">
                <span class="info-label">Owner Address:</span>
                <span class="info-value monospace">{{ selectedTicket?.blockchain_owner_address }}</span>
              </div-->
            </div>
          </div>

          <v-divider v-if="selectedTicket?.is_listed_for_sale || (selectedTicket?.resale_history && selectedTicket?.resale_history.length > 0)" class="my-4"></v-divider>
          <!-- Resale Information -->
          <div v-if="selectedTicket?.is_listed_for_sale || (selectedTicket?.resale_history && selectedTicket?.resale_history.length > 0)" class="details-section">
            <h3 class="section-title">
              <v-icon left>mdi-tag</v-icon>
              Resale Information
            </h3>
            
            <!-- Current Listing -->
            <div v-if="selectedTicket?.is_listed_for_sale" class="current-listing">
              <v-alert type="info" class="mb-3">
                <div class="listing-header">
                  <v-icon left>mdi-tag-outline</v-icon>
                  <span class="listing-title">Currently Listed for Sale</span>
                </div>
                <div class="info-grid mt-2">
                  <div class="info-item">
                    <span class="info-label">Asking Price:</span>
                    <span class="info-value">
                      <span v-if="selectedTicket?.resale_current_price_usd > 0">${{ selectedTicket?.resale_current_price_usd }}</span>
                      <span v-else-if="selectedTicket?.resale_current_price_muz > 0">{{ selectedTicket?.resale_current_price_muz }} MUZ</span>
                      <span v-else-if="selectedTicket?.resale_current_price_eur > 0">€{{ selectedTicket?.resale_current_price_eur }}</span>
                      <span v-else-if="selectedTicket?.resale_current_price_pln > 0">zł{{ selectedTicket?.resale_current_price_pln }}</span>
                      <span v-else-if="selectedTicket?.resale_current_price_btc > 0">₿{{ selectedTicket?.resale_current_price_btc }}</span>
                      <span v-else-if="selectedTicket?.resale_current_price_eth > 0">Ξ{{ selectedTicket?.resale_current_price_eth }}</span>

                    </span>
                  </div>
                </div>
              </v-alert>
            </div>

            <!-- Resale History -->
            <div v-if="selectedTicket?.resale_history && selectedTicket?.resale_history.length > 0" class="resale-history">
              <h4 class="subsection-title">Listing History</h4>
              <div class="resale-list">
                <div v-for="(listing, index) in selectedTicket.resale_history" :key="index" class="resale-item">
                  <div class="resale-header">
                    <v-icon size="16" :color="listing.sold ? 'success' : listing.withdraw_date ? 'grey' : 'info'">
                      {{ listing.sold ? 'mdi-check-circle' : listing.withdraw_date ? 'mdi-cancel' : 'mdi-tag' }}
                    </v-icon>
                    <span class="resale-number">Listing #{{ index + 1 }}</span>
                    <v-chip size="x-small" :color="listing.sold ? 'success' : listing.withdraw_date ? 'grey' : 'info'" variant="outlined">
                      {{ listing.sold ? 'Sold' : listing.withdraw_date ? 'Withdrawn' : 'Active' }}
                    </v-chip>
                  </div>
                  <div class="resale-details">
                    <div class="resale-detail-item">
                      <v-icon size="12">mdi-cash</v-icon>
                      <span>
                        <span v-if="listing.price_usd > 0">${{ listing.price_usd }}</span>
                        <span v-else-if="listing.price_muz > 0">{{ listing.price_muz }} MUZ</span>
                        <span v-else-if="listing.price_eur > 0">€{{ listing.price_eur }}</span>
                        <span v-else-if="listing.price_pln > 0">zł{{ listing.price_pln }}</span>
                        <span v-else-if="listing.price_btc > 0">₿{{ listing.price_btc }}</span>
                        <span v-else-if="listing.price_eth > 0">Ξ{{ listing.price_eth }}</span>
                      </span>
                    </div>
                    <div class="resale-detail-item">
                      <v-icon size="12">mdi-calendar-plus</v-icon>
                      <span>Listed: {{ formatDate(listing.listed_date) }}</span>
                    </div>
                    <div v-if="listing.sold && listing.sold_date" class="resale-detail-item">
                      <v-icon size="12" color="success">mdi-calendar-check</v-icon>
                      <span>Sold: {{ formatDate(listing.sold_date) }}</span>
                    </div>
                    <div v-else-if="listing.withdraw_date" class="resale-detail-item">
                      <v-icon size="12">mdi-calendar-remove</v-icon>
                      <span>Withdrawn: {{ formatDate(listing.withdraw_date) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <v-divider class="my-4"></v-divider>

          <!-- Payment Information -->
          <div class="details-section">
            <h3 class="section-title">
              <v-icon left>mdi-cash</v-icon>
              Payment Information
            </h3>
            <div class="info-grid">
              <div class="info-item">
                <span class="info-label">Price Paid:</span>
                <span class="info-value">{{ formatPrice(selectedTicket) }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Payment Method:</span>
                <span class="info-value">{{ selectedTicket?.payment_method }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Purchase Date:</span>
                <span class="info-value">{{ formatDateTime(selectedTicket?.payment_date) }}</span>
              </div>
              <div v-if="selectedTicket?.refund_policy" class="info-item">
                <span class="info-label">Refund Policy:</span>
                <span class="info-value">{{ formatRefundPolicy(selectedTicket?.refund_policy) }}</span>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="details-dialog-actions">
          <v-btn 
            v-if="selectedTicket?.promo_track_id && selectedTicket?.promo_track_playable" 
            variant="outlined" 
            color="success"
            :disabled="!selectedTicket?.promo_track_unlocked"
            @click="playPromoTrack(selectedTicket)"
          >
            <v-icon left>mdi-play-circle</v-icon>
            Play
          </v-btn>
          <v-btn variant="outlined" @click="downloadTicket(selectedTicket)">
            <v-icon left>mdi-download</v-icon>
            Download
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="showDetailsDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Share Dialog -->
    <v-dialog v-model="showShareDialog" max-width="600">
      <v-card class="share-dialog">
        <v-card-title class="share-dialog-header">
          <span>Share Ticket</span>
          <v-btn icon @click="showShareDialog = false" variant="text">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-text class="share-dialog-content">
          <div class="share-preview">
            <img :src="selectedTicket?.event_image" :alt="selectedTicket?.event_name" class="share-preview-image">
            <div class="share-preview-info">
              <h3>{{ selectedTicket?.event_name }}</h3>
                <p><v-icon size="16" class="mr-1">mdi-calendar</v-icon> {{ formatDate(selectedTicket?.event_date) }} 
                  <v-icon size="16" class="mx-1">mdi-clock-outline</v-icon> {{ selectedTicket?.event_time_start }}
                </p>
                <p>
                <v-icon size="16" class="mr-1">mdi-map-marker</v-icon>
                {{ selectedTicket?.event_location }}
                </p>
            </div>
          </div>

          <v-divider class="my-4"></v-divider>

          <!-- Include Seating Checkbox -->
          <v-checkbox
            v-model="shareIncludeSeating"
            label="Include my seating information"
            color="primary"
            hide-details
            class="share-checkbox"
            :disabled="!selectedTicket?.ticket_section && !selectedTicket?.ticket_row && !selectedTicket?.ticket_seat"
          >
            <template v-slot:label>
              <div class="checkbox-label">
                <span>Include my seating information</span>
                <span v-if="selectedTicket?.ticket_section || selectedTicket?.ticket_row || selectedTicket?.ticket_seat" class="seating-preview">
                  ({{ selectedTicket?.ticket_section ? `Section ${selectedTicket.ticket_section}` : '' }}
                  {{ selectedTicket?.ticket_row ? `, Row ${selectedTicket.ticket_row}` : '' }}
                  {{ selectedTicket?.ticket_seat ? `, Seat ${selectedTicket.ticket_seat}` : '' }})
                </span>
              </div>
            </template>
          </v-checkbox>

          <v-divider class="my-4"></v-divider>

          <!-- Share Options -->
          <div class="share-options pb-8">
            <h4 class="share-options-title">Share to:</h4>
            
            <!-- Verse -->
            <v-btn
              v-if="this.user && this.user.verse_username && this.user.verse_username !== ''"
              variant="outlined"
              class="share-option-btn verse-btn"
              block
              @click="shareToVerse(selectedTicket, shareIncludeSeating)"
            >
              <v-icon left>mdi-music-note</v-icon>
              Share to Verse
              <v-chip size="x-small" class="ml-2" color="primary">Recommended</v-chip>
            </v-btn>

            <!-- Twitter/X -->
            <v-btn
              variant="outlined"
              class="share-option-btn twitter-btn"
              block
              @click="shareToTwitter(selectedTicket, shareIncludeSeating)"
            >
              <v-icon left>mdi-twitter</v-icon>
              Share to X (Twitter)
            </v-btn>

            <!-- Facebook -->
            <v-btn
              variant="outlined"
              class="share-option-btn facebook-btn"
              block
              @click="shareToFacebook(selectedTicket)"
            >
              <v-icon left>mdi-facebook</v-icon>
              Share to Facebook
            </v-btn>

            <!-- Native Share (Mobile) -->
            <v-btn
              v-if="showNativeShareButton"
              variant="outlined"
              class="share-option-btn"
              block
              @click="nativeShare(selectedTicket, shareIncludeSeating)"
            >
              <v-icon left>mdi-share-variant</v-icon>
              Share via...
            </v-btn>

            <!-- Share with Image -->
            <v-btn
              variant="outlined"
              class="share-option-btn"
              block
              @click="shareWithImage(selectedTicket, shareIncludeSeating)"
            >
              <v-icon left>mdi-image</v-icon>
              Share as Image
            </v-btn>

            <!-- Copy Link -->
            <v-btn
              variant="outlined"
              class="share-option-btn"
              block
              @click="copyTicketLink(selectedTicket)"
            >
              <v-icon left>mdi-link</v-icon>
              Copy Event Link
            </v-btn>
          </div>

          <v-alert type="info" density="compact" class="mt-4 share-note">
            <div class="share-note-content">
              <v-icon size="16">mdi-shield-check</v-icon>
              <span>Your QR code will not be shared for security reasons</span>
            </div>
          </v-alert>
        </v-card-text>
      </v-card>
    </v-dialog>


        <!-- Transfer Ticket Dialog -->
    <v-dialog v-model="showTransferDialog" max-width="600">
      <v-card class="transfer-dialog">
        <v-card-title class="transfer-dialog-header">
            <div class="transfer-header-content">
            <v-icon left>mdi-send</v-icon>
            <span>Transfer Ticket</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeTransferDialog" variant="text">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            </div>
        </v-card-title>
        
        <v-card-text class="transfer-dialog-content">
          <!-- Ticket Preview -->
          <div class="transfer-ticket-preview">
            <img :src="selectedTicket?.event_image" :alt="selectedTicket?.event_name" class="transfer-ticket-image">
            <div class="transfer-ticket-info">
              <h3>{{ selectedTicket?.event_name }}</h3>
              <p>
                <v-icon size="14">mdi-calendar</v-icon>
                {{ formatDate(selectedTicket?.event_date) }}
              </p>
              <p>
                <v-icon size="14">mdi-ticket</v-icon>
                {{ selectedTicket?.ticket_type }}
              </p>
            </div>
          </div>

          <v-divider class="my-4"></v-divider>

          <!-- Transfer Steps -->
          <div class="transfer-steps">
            <!-- Step 1: Search User -->
            <div v-if="transferStep === 1" class="transfer-step">
              <h4 class="step-title">
                <v-icon left color="primary" class="pr-1">mdi-numeric-1-circle</v-icon>
                Search for recipient
              </h4>
              
              <v-text-field
                v-model="transferSearchQuery"
                placeholder="Search by Verse username..."
                prepend-inner-icon="mdi-magnify"
                variant="outlined"
                density="comfortable"
                hide-details
                clearable
                class="transfer-search-field"
                @input="searchUsersForTransfer"
                :loading="searchingUsers"
              >
                <template v-slot:append-inner>
                  <v-fade-transition>
                    <v-icon v-if="transferSearchQuery && transferSearchQuery.length > 0" size="small" color="success">
                      mdi-account-search
                    </v-icon>
                  </v-fade-transition>
                </template>
              </v-text-field>

              <!-- Search Results -->
              <div v-if="transferSearchResults.length > 0" class="transfer-search-results">
                <div class="search-results-header">
                  <span>Found {{ transferSearchResults.length }} user{{ transferSearchResults.length !== 1 ? 's' : '' }}</span>
                </div>
                <v-list class="transfer-users-list">
                  <v-list-item
                    v-for="user in transferSearchResults"
                    :key="user.id"
                    @click="selectTransferRecipient(user)"
                    class="transfer-user-item"
                  >
                    <template v-slot:prepend>
                      <v-avatar size="40" :color="user.avatar_url ? 'transparent' : 'primary'">
                        <img v-if="user.avatar_url" :src="user.avatar_url" :alt="user.verse_username">
                        <span v-else class="avatar-text">{{ user.verse_username ? user.verse_username.charAt(0).toUpperCase() : 'U' }}</span>
                      </v-avatar>
                    </template>
                    <v-list-item-title>
                      @{{ user.verse_username }}
                      <v-icon v-if="user.is_verified" size="14" color="primary" class="ml-1">mdi-check-decagram</v-icon>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <div class="user-status" :class="{ 'online': user.isOnline }">
                        <span class="status-dot" :class="{ 'online': user.isOnline, 'offline': !user.isOnline }"></span>
                        <span>{{ user.isOnline ? 'Online' : 'Offline' }}</span>
                      </div>
                    </v-list-item-subtitle>
                    <template v-slot:append>
                      <v-icon>mdi-chevron-right</v-icon>
                    </template>
                  </v-list-item>
                </v-list>
              </div>

              <!-- No Results -->
              <div v-else-if="transferSearchQuery && transferSearchQuery.length >= 3 && !searchingUsers" class="transfer-no-results">
                <v-icon size="48" color="grey">mdi-account-search-outline</v-icon>
                <p>No users found matching "{{ transferSearchQuery }}"</p>
              </div>

              <!-- Search Hint -->
              <v-alert v-if="!transferSearchQuery || transferSearchQuery.length < 3" type="info" density="compact" class="mt-4">
                <div class="search-hint">
                  <v-icon size="16">mdi-information</v-icon>
                  <span>Enter at least 3 characters to search for users</span>
                </div>
              </v-alert>
            </div>

            <!-- Step 2: Confirm Transfer -->
            <div v-if="transferStep === 2" class="transfer-step">
              <h4 class="step-title">
                <v-icon left color="primary" class="pr-1">mdi-numeric-2-circle</v-icon>
                Confirm transfer
              </h4>

              <!-- Recipient Info -->
              <div class="transfer-recipient-card">
                <div class="recipient-header">
                  <span class="recipient-label">Transfer to:</span>
                </div>
                <div class="recipient-info">
                  <v-avatar size="48" color="primary">
                    <span class="avatar-text">{{ selectedTransferRecipient.verse_username.charAt(0).toUpperCase() }}</span>
                  </v-avatar>
                  <div class="recipient-details">
                    <div class="recipient-username">
                      @{{ selectedTransferRecipient.verse_username }}
                    </div>
                    <div  class="recipient-display-name">
                      <div class="user-status" :class="{ 'online': selectedTransferRecipient.isOnline }">
                      <span class="status-dot" :class="{ 'online': selectedTransferRecipient.isOnline, 'offline': !selectedTransferRecipient.isOnline }"></span>
                      <span>{{ selectedTransferRecipient.isOnline ? 'Online' : 'Offline' }}</span>
                      </div>
                    </div>
                  </div>
                  <v-btn icon size="small" @click="transferStep = 1" variant="text">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </div>
              </div>

              <!-- Transfer Info -->
              <v-alert type="warning" class="transfer-warning mt-4">
                <div class="warning-content">
                  <div>
                    <div class="warning-title">Important Information</div>
                    <ul class="warning-list">
                      <li>This action cannot be undone</li>
                      <li>The ticket will be permanently transferred to @{{ selectedTransferRecipient.verse_username }}</li>
                      <li>You will lose all access to this ticket</li>
                      <li v-if="selectedTicket?.transfer_max > -1 && selectedTicket?.transfer_count >= selectedTicket?.transfer_max">
                        ⚠️ This ticket has reached its maximum transfer limit ({{ selectedTicket.transfer_count }}/{{ selectedTicket.transfer_max }})
                      </li>
                    </ul>
                  </div>
                </div>
              </v-alert>

              <!-- Password Confirmation -->
              <div class="password-confirmation">
                <h5 class="confirmation-title">Enter your password to confirm</h5>
                <v-text-field
                  v-model="transferPassword"
                  type="password"
                  placeholder="Your account password"
                  prepend-inner-icon="mdi-lock"
                  variant="outlined"
                  density="comfortable"
                  hide-details
                  class="password-field"
                  :error="transferPasswordError"
                  :error-messages="transferPasswordError ? 'Invalid password' : ''"
                ></v-text-field>
              </div>
            </div>

            <!-- Step 3: Processing/Success -->
            <div v-if="transferStep === 3" class="transfer-step">
              <div v-if="transferring" class="transfer-processing">
                <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
                <h4>Transferring ticket...</h4>
                <p>Please wait while we process your transfer</p>
              </div>
              <div v-else-if="transferSuccess" class="transfer-success">
                <v-icon size="64" color="success">mdi-check-circle</v-icon>
                <h4>Transfer Successful!</h4>
                <p>The ticket has been transferred to @{{ selectedTransferRecipient.verse_username }}</p>
                <v-btn variant="outlined" @click="closeTransferDialog" class="mt-4">
                  Close
                </v-btn>
              </div>
            </div>
          </div>
        </v-card-text>

        <v-card-actions v-if="transferStep < 3" class="transfer-dialog-actions">
          <v-btn 
            v-if="transferStep === 2" 
            variant="text" 
            @click="transferStep = 1"
          >
            <v-icon left>mdi-arrow-left</v-icon>
            Back
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="closeTransferDialog">Cancel</v-btn>
          <v-btn 
            v-if="transferStep === 2"
            color="primary" 
            variant="outlined"
            class="action-btn"

            @click="confirmTransfer"
            :disabled="!transferPassword || transferPassword.length === 0 || (selectedTicket?.transfer_max > -1 && selectedTicket?.transfer_count >= selectedTicket?.transfer_max)"
            :loading="transferring"
          >
            <v-icon left>mdi-send</v-icon>
            Transfer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import { useMobile } from '../composables/useMobile.js'
import { useMobilePlayer3 } from '../composables/useMobilePlayer3.js'
import { useMobileXs } from '../composables/useMobileXs.js'
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import QRCodeVue3 from 'qrcode-vue3';
import chatService from '@/services/chat/ChatService';

export default {
  setup() {
    const isMobile = useMobile()
    const isMobileXs = useMobileXs()
    const isMobilePlayer3 = useMobilePlayer3();

    const notify = (message) => {
      toast(message, {
        theme: "dark",
        type: "success",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 1500,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    const notifyError = (message) => {
      toast(message, {
        theme: "dark",
        type: "error",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 3000,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    return { isMobile, isMobileXs, notify, notifyError, isMobilePlayer3 }
  },
  name: 'Tickets',

  components: {
        QRCodeVue3
  },
  data: () => ({
    navbar: false,
    user: null,
    tickets: [],
    filterStatus: 'all',
    showQRDialog: false,
    showDetailsDialog: false,
    selectedTicket: null,
    showShareDialog: false,
    shareIncludeSeating: false,
    searchQuery: '',

    // Pagination
    currentPage: 1,
    ticketsPerPage: 2,
    totalTickets: 0,
    totalPages: 1,
    loadingMore: false,
    allTicketsLoaded: false,

    // Transfer Dialog
    showTransferDialog: false,
    transferStep: 1, // 1: Search, 2: Confirm, 3: Processing/Success
    transferSearchQuery: '',
    transferSearchResults: [],
    searchingUsers: false,
    selectedTransferRecipient: null,
    transferPassword: '',
    transferPasswordError: false,
    transferring: false,
    transferSuccess: false,
    transferSearchTimeout: null,

  }),
  mounted() {   
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  beforeUnmount() {
    if (this.transferSearchTimeout) {
      clearTimeout(this.transferSearchTimeout)
      this.transferSearchTimeout = null
    }
  },
  destroyed() {
  },
  watch: {
    '$store.state.user': function() {
          this.user = this.$store.getters.getUserData;
      },    
  showTransferDialog(newVal, oldVal) {
    if (oldVal && !newVal) {
      // Dialog został zamknięty
      if (this.transferSearchTimeout) {
        clearTimeout(this.transferSearchTimeout);
        this.transferSearchTimeout = null;
      }
      this.searchingUsers = false;
    }
  },
  
  transferStep(newStep, oldStep) {
    if (oldStep === 1 && newStep === 2) {
      // Przeszliśmy z wyszukiwania do potwierdzenia
      if (this.transferSearchTimeout) {
        clearTimeout(this.transferSearchTimeout);
        this.transferSearchTimeout = null;
      }
      this.searchingUsers = false;
    }
  }
  },
  computed: {
    showNativeShareButton() {
      // Sprawdź czy navigator.share jest dostępny
      return this.isMobile && 
             typeof navigator !== 'undefined' && 
             'share' in navigator;
    },
    filteredTickets() {
      let filtered = this.tickets;

      // Apply status filter
      if (this.filterStatus === 'active') {
        filtered = filtered.filter(t => (t.status === 'active' || t.status === 'used') && !this.isExpired(t));
      } else if (this.filterStatus === 'used') {
        filtered = filtered.filter(t => t.is_used || t.status === 'used');
      } else if (this.filterStatus === 'nft') {
        filtered = filtered.filter(t => t.is_nft === 1);
      } else if (this.filterStatus === 'non-nft') {
        filtered = filtered.filter(t => !t.is_nft || t.is_nft === 0);
      } else if (this.filterStatus === 'cancelled') {
        filtered = filtered.filter(t => t.status === 'cancelled');
      } else if (this.filterStatus === 'refunded') {
        filtered = filtered.filter(t => t.is_refunded);
      }

      // Apply search filter
      if (this.searchQuery && this.searchQuery.trim().length > 0) {
        const query = this.searchQuery.toLowerCase().trim();
        
        filtered = filtered.filter(ticket => {
          // Search in event name
          const matchEventName = ticket.event_name && 
            ticket.event_name.toLowerCase().includes(query);
          
          // Search in location
          const matchLocation = ticket.event_location && 
            ticket.event_location.toLowerCase().includes(query);
          
          // Search in location address
          const matchAddress = ticket.event_location_address && 
            ticket.event_location_address.toLowerCase().includes(query);
          
          // Search in organizer name
          const matchOrganizer = ticket.issuer_name && 
            ticket.issuer_name.toLowerCase().includes(query);
          
          // Search in ticket type
          const matchTicketType = ticket.ticket_type && 
            ticket.ticket_type.toLowerCase().includes(query);
          
          // Search in ticket category
          const matchTicketCategory = ticket.ticket_category && 
            ticket.ticket_category.toLowerCase().includes(query);
          
          // Search in ticket number
          const matchTicketNumber = ticket.ticket_number && 
            ticket.ticket_number.toLowerCase().includes(query);

          // Search in event date
          const matchDate = this.formatDate(ticket.event_date).toLowerCase().includes(query);

          return matchEventName || 
                 matchLocation || 
                 matchAddress || 
                 matchOrganizer || 
                 matchTicketType || 
                 matchTicketCategory || 
                 matchTicketNumber ||
                 matchDate;
        });
      }

      return filtered;
    },
    oldestTicketDate() {
      if (this.tickets.length === 0) return null;
      
      // Znajdź najstarszą datę z załadowanych ticketów
      const oldestTicket = this.tickets.reduce((oldest, ticket) => {
        if (!oldest) return ticket;
        const oldestDate = new Date(oldest.event_date);
        const currentDate = new Date(ticket.event_date);
        return currentDate < oldestDate ? ticket : oldest;
      }, null);

      if (!oldestTicket) return null;
      
      return this.formatDate(oldestTicket.event_date);
    },

    showLoadMoreButton() {
      return !this.allTicketsLoaded && 
             this.tickets.length > 0 && 
             this.currentPage < this.totalPages;
    },

    isIOS() {
      return /iPhone|iPad|iPod/i.test(navigator.userAgent);
    },
    
    isAndroid() {
      return /Android/i.test(navigator.userAgent);
    },

    isfullScreen() {
      if (this.isMobile && this.isMobileXs) {
        return false;
      } else {
        return true;
      }
    },

    isLogged() {
      return this.$store.getters.getUserData != null
    },

    isDesktop() {
      if (!this.navbar) {
        return true;
      } else {
        return false;
      }
    },

    getGextPanel() {
      if (this.navbar) {
        if (this.isMobileXs) {
          return 'textPanelMobileXs'
        } else {
          return 'textPanelMobile';
        }
      } else return 'textPanel';
    },

  },  
  created() {
    if (this.$store.getters.getUserData != null) {
      this.user = this.$store.getters.getUserData;    

      if(window.innerWidth > 768){
        this.navbar = false;
      } else {
        this.navbar = true;
      }

      this.fetchTickets();

        // Polyfill dla roundRect (starsze przeglądarki)
        if (!CanvasRenderingContext2D.prototype.roundRect) {
          CanvasRenderingContext2D.prototype.roundRect = function (x, y, w, h, r) {
            if (w < 2 * r) r = w / 2;
            if (h < 2 * r) r = h / 2;
            this.beginPath();
            this.moveTo(x + r, y);
            this.arcTo(x + w, y, x + w, y + h, r);
            this.arcTo(x + w, y + h, x, y + h, r);
            this.arcTo(x, y + h, x, y, r);
            this.arcTo(x, y, x + w, y, r);
            this.closePath();
            return this;
          };
        }

    }
  }, 
  methods: {

    async fetchTickets(page = 1, append = false) {
      if (this.loadingMore && append) return; // Prevent duplicate requests

      if (append) {
        this.loadingMore = true;
      }

      try {
        const response = await this.$store.dispatch('getTickets', {
          token: this.user.token,
          page: page,
          limit: this.ticketsPerPage
        });

        if (response) {
          // Backend zwraca strukturę z tickets i pagination
          const newTickets = response.tickets || [];
          const pagination = response.pagination || {};

          if (append) {
            // Append new tickets (Load Older)
            this.tickets = [...this.tickets, ...newTickets];
          } else {
            // Replace tickets (initial load lub refresh)
            
            this.tickets = newTickets;
          }

          // Aktualizuj dane paginacji
          this.currentPage = pagination.page || page;
          this.totalTickets = pagination.total || this.tickets.length;
          this.totalPages = pagination.total_pages || 1;

          // Sprawdź czy załadowano wszystkie bilety
          this.allTicketsLoaded = this.currentPage >= this.totalPages;

        }
      } catch (error) {
        console.error('Error fetching tickets:', error);
        this.notifyError('Failed to load tickets');
      } finally {
        this.loadingMore = false;
      }
    },

    async loadOlderTickets() {
      if (this.loadingMore || this.allTicketsLoaded) return;

      const nextPage = this.currentPage + 1;
      await this.fetchTickets(nextPage, true);

      if (this.tickets.length > 0) {
        this.notify(`Loaded ${this.ticketsPerPage} older tickets`);
      }
    },
    async refreshTickets() {
      this.currentPage = 1;
      this.allTicketsLoaded = false;
      await this.fetchTickets(1, false);
      this.notify('Tickets refreshed');
    },

    isPerkExpired(perk) {
      if (!perk.perk_valid_until) return false;
      const now = new Date();
      const validUntil = new Date(perk.perk_valid_until);
      return now > validUntil;
    },

    checkScreenSize() {
      if(window.innerWidth > 768){
        this.navbar = false;
      } else {
        this.navbar = true;
      }
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', { 
        weekday: 'short', 
        year: 'numeric', 
        month: 'short', 
        day: 'numeric' 
      });
    },
    formatDateTime(dateTimeString) {
      if (!dateTimeString) return '';
      const date = new Date(dateTimeString);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },

  contactSupport() {
    window.location.href = 'https://muzible.com/contact';
  },

    getLanguageFlag(language) {
      // Check if language is an array or a single value
    const flags = {
        // Original
        'en': '🇬🇧',
        'es': '🇪🇸',
        'fr': '🇫🇷',
        'de': '🇩🇪',
        'it': '🇮🇹',
        'pt': '🇵🇹',
        'zh': '🇨🇳',
        'ja': '🇯🇵',
        'ko': '🇰🇷',
        'ru': '🇷🇺',
        'pl': '🇵🇱',
        'nl': '🇳🇱',
        'sv': '🇸🇪',
        'tr': '🇹🇷',
        'ar': '🇸🇦',
        'hi': '🇮🇳',
        // European Countries
        'sq': '🇦🇱', // Albanian
        'de-AT': '🇦🇹', // Austrian German
        'nl-BE': '🇧🇪', // Belgian Dutch
        'fr-BE': '🇧🇪', // Belgian French
        'bg': '🇧🇬', // Bulgarian
        'hr': '🇭🇷', // Croatian
        'cs': '🇨🇿', // Czech
        'da': '🇩🇰', // Danish
        'et': '🇪🇪', // Estonian
        'fi': '🇫🇮', // Finnish
        'el': '🇬🇷', // Greek
        'hu': '🇭🇺', // Hungarian
        'is': '🇮🇸', // Icelandic
        'ga': '🇮🇪', // Irish
        'lv': '🇱🇻', // Latvian
        'lt': '🇱🇹', // Lithuanian
        'lb': '🇱🇺', // Luxembourgish
        'mt': '🇲🇹', // Maltese
        'no': '🇳🇴', // Norwegian
        'nb': '🇳🇴', // Norwegian Bokmål
        'nn': '🇳🇴', // Norwegian Nynorsk
        'ro': '🇷🇴', // Romanian
        'sr': '🇷🇸', // Serbian
        'sk': '🇸🇰', // Slovak
        'sl': '🇸🇮', // Slovenian
        'de-CH': '🇨🇭', // Swiss German
        'fr-CH': '🇨🇭', // Swiss French
        'it-CH': '🇨🇭', // Swiss Italian
        'uk': '🇺🇦', // Ukrainian
        'be': '🇧🇾', // Belarusian
        'bs': '🇧🇦', // Bosnian
        'mk': '🇲🇰', // Macedonian
        'me': '🇲🇪', // Montenegrin
        'pt-PT': '🇵🇹', // Portuguese (Portugal)
        // USA & Americas
        'en-US': '🇺🇸', // American English
        'en-CA': '🇨🇦', // Canadian English
        'fr-CA': '🇨🇦', // Canadian French
        'es-MX': '🇲🇽', // Mexican Spanish
        'es-AR': '🇦🇷', // Argentine Spanish
        'pt-BR': '🇧🇷', // Brazilian Portuguese
        'es-CL': '🇨🇱', // Chilean Spanish
        'es-CO': '🇨🇴', // Colombian Spanish
        'es-PE': '🇵🇪', // Peruvian Spanish
        'es-VE': '🇻🇪', // Venezuelan Spanish
        'es-EC': '🇪🇨', // Ecuadorian Spanish
        'es-BO': '🇧🇴', // Bolivian Spanish
        'es-UY': '🇺🇾', // Uruguayan Spanish
        'es-PY': '🇵🇾', // Paraguayan Spanish
      };

      if (Array.isArray(language)) {
        return language.map(lang => {
          const trimmedLang = lang.trim();
          return flags[trimmedLang] || '🏳️';
        }).join(' ');
      }
      
      return flags[language] || '🏳️';
    },

    formatPrice(ticket) {
      if (!ticket) return '';
      
      if (ticket.price_paid_usd > 0) {
        return `$${ticket.price_paid_usd} $`;
      } else if (ticket.price_paid_eur > 0) {
        return `€${ticket.price_paid_eur} EUR`;
      } else if (ticket.price_paid_muz > 0) {
        return `${ticket.price_paid_muz} MUZ`;
      } else if (ticket.price_paid_eth > 0) {
        return `${ticket.price_paid_eth} ETH`;
      } else if (ticket.price_paid_pln > 0) {
        return `${ticket.price_paid_pln} PLN`;
      } else if (ticket.price_paid_btc > 0) {
        return `${ticket.price_paid_btc} BTC`;
      }
      return 'Free';
    },
    isNow(ticket){
      if (!ticket || !ticket.event_date) return false;
      
      try {
        const now = new Date();
        
        // Utwórz datę początkową z event_date i event_time_start
        let startDateTimeStr = ticket.event_date;
        if (ticket.event_time_start && ticket.event_time_start.length > 0) {
          // Jeśli event_time_start wygląda jak pełny timestamp
          if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(ticket.event_time_start)) {
            startDateTimeStr = ticket.event_time_start;
          } else {
            // W przeciwnym razie połącz event_date i event_time_start
            startDateTimeStr = `${ticket.event_date} ${ticket.event_time_start}`;
          }
        }
        
        const eventStartDate = new Date(startDateTimeStr);
        
        // Jeśli eventStartDate jest nieprawidłowy
        if (isNaN(eventStartDate.getTime())) {
          return false;
        }
        
        // Utwórz datę końcową z event_date i event_time_end
        let endDateTimeStr = ticket.event_date;
        if (ticket.event_time_end && ticket.event_time_end.length > 0) {
          // Jeśli event_time_end wygląda jak pełny timestamp
          if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(ticket.event_time_end)) {
            endDateTimeStr = ticket.event_time_end;
          } else {
            // W przeciwnym razie połącz event_date i event_time_end
            endDateTimeStr = `${ticket.event_date} ${ticket.event_time_end}`;
          }
        } else if (ticket.event_time_start) {
          // Jeśli nie ma event_time_end, dodaj 4 godziny do startu jako domyślny czas trwania
          const defaultEndDate = new Date(eventStartDate);
          defaultEndDate.setHours(defaultEndDate.getHours() + 4);
          endDateTimeStr = defaultEndDate.toISOString();
        } else {
          // Jeśli nie ma żadnego czasu, sprawdź tylko czy data się zgadza
          return eventStartDate.toDateString() === now.toDateString();
        }
        
        const eventEndDate = new Date(endDateTimeStr);
        
        // Jeśli eventEndDate jest nieprawidłowy, użyj eventStartDate + 4 godziny
        if (isNaN(eventEndDate.getTime())) {
          const defaultEndDate = new Date(eventStartDate);
          defaultEndDate.setHours(defaultEndDate.getHours() + 4);
          return now >= eventStartDate && now <= defaultEndDate;
        }
        // Sprawdź czy teraz jest między startem a końcem eventu
        return now >= eventStartDate && now <= eventEndDate;
        
      } catch (error) {
        return false;
      }
    },
    isExpired(ticket) {
      if (!ticket || !ticket.event_date) return false;
      // Use event_time_end if available, otherwise fallback to event_time_start or just date
      let eventDateTimeStr = ticket.event_date;
      if (ticket.event_time_end && ticket.event_time_end.length > 0) {
        // If event_time_end looks like a full timestamp, use it directly
        if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(ticket.event_time_end)) {
          eventDateTimeStr = ticket.event_time_end;
        } else {
          // Otherwise, combine event_date and event_time_end
          eventDateTimeStr = `${ticket.event_date} ${ticket.event_time_end}`;
        }
      } else if (ticket.event_time_start && ticket.event_time_start.length > 0) {
        eventDateTimeStr = `${ticket.event_date} ${ticket.event_time_start}`;
      }
      const eventDate = new Date(eventDateTimeStr);
      return eventDate < new Date();
    },

    formatRefundPolicy(policy) {
      const policies = {
        'refundable_30_days': 'Refundable (30 days)',
        'refundable_until_event': 'Refundable until event',
        'non_refundable': 'Non-refundable'
      };
      return policies[policy] || policy;
    },


    getStatusColor(ticket, status) {
      if (status === 'active' && this.isExpired(ticket)) {
        return 'error'; // expired
      }
      const colors = {
        'active': 'success',
        'used': 'grey',
        'cancelled': 'error',
        'refunded': 'warning',
        'expired': 'error'
      };
      return colors[status] || 'grey';
    },

    canRefund(ticket) {
      if (!ticket) return false;
      return ticket.refund_policy !== 'non_refundable' &&
        !ticket.is_used &&
        !ticket.is_refunded &&
        ticket.status !== 'cancelled' &&
        !this.isExpired(ticket) &&
        !ticket.refund_requested &&
        !ticket.refund_rejected;
    },

    canRequestRefund(ticket) {
      if (!ticket) return false;
      return !ticket.is_used &&
        ticket.status === 'cancelled' &&
        !ticket.is_refunded &&
        !ticket.refund_requested &&
        !ticket.refund_rejected;
    },

    requestRefund(ticket) {
      if (!ticket) {
        this.notifyError('No ticket selected');
        return;
      }
      if (!this.user) {
        this.notifyError('You must be logged in to request a refund');
        return;
      }
      this.$store.dispatch('requestTicketRefund', {
        ticket_id: ticket.id,
        token: this.user.token
      }).then(() => {
        this.notify('Refund request submitted for ticket #' + ticket.ticket_number);
        this.fetchTickets();

      }).catch(() => {
        this.notifyError('Failed to submit refund request');
      });
    },
  
    showQRCode(ticket) {
      this.selectedTicket = ticket;
      this.showQRDialog = true;
    },

    showTicketDetails(ticket) {
      this.selectedTicket = ticket;
      this.showDetailsDialog = true;
    },

    async downloadQR() {
      if (!this.selectedTicket) {
        this.notifyError('No ticket selected');
        return;
      }

      try {
        // Poczekaj na pełne renderowanie
        await this.$nextTick();
        
        // Spróbuj znaleźć canvas (fallback)
        let qrCodeElement = document.querySelector('.qr-code-card canvas');
        
        // Jeśli nie ma canvas, szukaj <img> z data URL
        if (!qrCodeElement) {
          const imgElement = document.querySelector('.qr-code-card img');
          
          if (!imgElement || !imgElement.src || !imgElement.src.startsWith('data:image/png')) {
            this.notifyError('QR Code not found. Please try again.');
            return;
          }

          // Konwertuj Data URL do Blob
          this.downloadQRFromDataURL(imgElement.src);
          return;
        }

        // Sprawdź czy canvas ma poprawne wymiary
        if (qrCodeElement.width === 0 || qrCodeElement.height === 0) {
          this.notifyError('QR Code not fully loaded. Please try again.');
          return;
        }

        // Konwertuj canvas do blob
        qrCodeElement.toBlob((blob) => {
          if (!blob) {
            this.notifyError('Failed to generate QR Code image');
            return;
          }

          this.processQRDownload(blob);
        }, 'image/png', 1.0);

      } catch (error) {
        this.notifyError('Failed to download QR Code');
      }
    },

    downloadQRFromDataURL(dataURL) {
      try {
        // Konwertuj Data URL do Blob
        const byteString = atob(dataURL.split(',')[1]);
        const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
        
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        
        const blob = new Blob([ab], { type: mimeString });
        
        console.log('QR Code converted from Data URL:', {
          size: blob.size,
          type: blob.type
        });

        this.processQRDownload(blob);
        
      } catch (error) {
        this.notifyError('Failed to process QR Code');
      }
    },

    processQRDownload(blob) {
      // Przygotuj nazwę pliku
      const ticketNumber = this.selectedTicket.ticket_number || 'ticket';
      const eventName = this.selectedTicket.event_name
        .replace(/[^a-z0-9]/gi, '_')
        .toLowerCase()
        .substring(0, 30);
      const fileName = `muzible_ticket_${eventName}_${ticketNumber}.png`;

      // Sprawdź czy to urządzenie mobilne
      const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      const isIOSDevice = /iPhone|iPad|iPod/i.test(navigator.userAgent);

      if (isMobileDevice && isIOSDevice && window.navigator.standalone !== undefined) {
        // iOS - spróbuj dodać do Apple Wallet
        this.addToAppleWallet();
      } else if (isMobileDevice && 'share' in navigator && navigator.canShare && navigator.canShare({ files: [new File([blob], fileName, { type: 'image/png' })] })) {
        // Mobile z Web Share API
        const file = new File([blob], fileName, { type: 'image/png' });
        
        navigator.share({
          title: `Ticket: ${this.selectedTicket.event_name}`,
          text: `Ticket #${this.selectedTicket.ticket_number}`,
          files: [file]
        }).then(() => {
          this.notify('QR Code shared successfully!');
        }).catch((error) => {
          // Fallback do normalnego pobierania
          if (error.name !== 'AbortError') {
            this.downloadQRFallback(blob, fileName);
          }
        });
      } else {
        // Desktop lub fallback - zwykłe pobieranie
        this.downloadQRFallback(blob, fileName);
      }
    },

    downloadQRFallback(blob, fileName) {
      try {
        // Utwórz URL dla blob
        const url = URL.createObjectURL(blob);

        // Utwórz tymczasowy link do pobrania
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.style.display = 'none';

        // Dodaj do DOM, kliknij i usuń
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Zwolnij URL
        setTimeout(() => URL.revokeObjectURL(url), 100);

        this.notify('QR Code downloaded successfully!');
      } catch (error) {
        this.notifyError('Failed to download file');
      }
    },

    async addToAppleWallet() {
      // Wymaga backend endpoint do generowania .pkpass file
      try {
        const response = await this.$store.dispatch('generateAppleWalletPass', {
          ticket_id: this.selectedTicket.id,
          token: this.user.token
        });

        if (response && response.pass_url) {
          // Otwórz URL z .pkpass - iOS automatycznie otworzy Wallet
          window.location.href = response.pass_url;
          this.notify('Opening Apple Wallet...');
        } else {
          throw new Error('No pass URL received');
        }
      } catch (error) {        
        // Fallback - pobierz QR jako PNG
        this.notifyError('Apple Wallet not available, downloading QR Code instead');
        
        await this.$nextTick();
        
        // Spróbuj pobrać z canvas
        let qrCodeElement = document.querySelector('.qr-code-card canvas');
        
        if (qrCodeElement) {
          qrCodeElement.toBlob((blob) => {
            if (blob) {
              const fileName = `muzible_ticket_${this.selectedTicket.ticket_number}.png`;
              this.downloadQRFallback(blob, fileName);
            }
          }, 'image/png', 1.0);
        } else {
          // Fallback - pobierz z img data URL
          const imgElement = document.querySelector('.qr-code-card img');
          if (imgElement && imgElement.src && imgElement.src.startsWith('data:image/png')) {
            this.downloadQRFromDataURL(imgElement.src);
          }
        }
      }
    },

    async addToGoogleWallet() {
      // Wymaga Google Wallet API i backend endpoint
      try {
        const response = await this.$store.dispatch('generateGoogleWalletPass', {
          ticket_id: this.selectedTicket.id,
          token: this.user.token
        });

        if (response && response.save_url) {
          // Otwórz Google Wallet save URL
          window.open(response.save_url, '_blank');
          this.notify('Opening Google Wallet...');
        } else {
          throw new Error('No save URL received');
        }
      } catch (error) {        
        this.notifyError('Google Wallet not available');
      }
    },

    downloadTicket(ticket) {
      if (!ticket) {
        this.notifyError('No ticket selected');
        return;
      }

      this.notify('Generating ticket image...');

      // Twórz canvas dla biletu
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // Rozmiar biletu (format landscape)
      const width = 1200;
      const height = 600;
      canvas.width = width;
      canvas.height = height;

      // Background gradient
      const gradient = ctx.createLinearGradient(0, 0, width, height);
      gradient.addColorStop(0, '#1a1a1a');
      gradient.addColorStop(0.5, '#2d2d2d');
      gradient.addColorStop(1, '#1a1a1a');
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, width, height);

      // Border
      ctx.strokeStyle = ticket.is_nft ? '#627eea' : 'rgba(255, 255, 255, 0.3)';
      ctx.lineWidth = 4;
      ctx.strokeRect(10, 10, width - 20, height - 20);

      // NFT Badge (jeśli NFT)
      if (ticket.is_nft) {
        ctx.fillStyle = '#627eea';
        ctx.fillRect(20, 20, 100, 40);
        ctx.fillStyle = '#ffffff';
        ctx.font = 'bold 18px Arial';
        ctx.fillText('NFT', 50, 47);
      }

      // Status Badge (góra prawy róg)
      const statusX = width - 150;
      const statusY = 30;
      let statusColor = '#4caf50'; // active
      let statusText = 'ACTIVE';

      if (ticket.status === 'cancelled') {
        statusColor = '#d32f2f';
        statusText = 'CANCELLED';
      } else if (ticket.is_refunded) {
        statusColor = '#ff9800';
        statusText = 'REFUNDED';
      } else if (ticket.is_used) {
        statusColor = '#9e9e9e';
        statusText = 'USED';
      } else if (this.isExpired(ticket)) {
        statusColor = '#d32f2f';
        statusText = 'EXPIRED';
      }

      ctx.fillStyle = statusColor;
      ctx.fillRect(statusX, statusY, 120, 35);
      ctx.fillStyle = '#ffffff';
      ctx.font = 'bold 14px Arial';
      ctx.textAlign = 'center';
      ctx.fillText(statusText, statusX + 60, statusY + 23);
      ctx.textAlign = 'left';

      // Event Image (left side)
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.src = ticket.image_full || ticket.event_image;

      img.onload = () => {
        // Draw image
        ctx.save();
        ctx.beginPath();
        ctx.roundRect(30, 80, 350, 480, 12);
        ctx.clip();
        ctx.drawImage(img, 30, 80, 350, 480);
        ctx.restore();

        // Continue with text rendering
        this.renderTicketText(ctx, ticket, width, height);
      };

      img.onerror = () => {
        // Jeśli obrazek się nie załaduje, rysuj placeholder
        ctx.fillStyle = 'rgba(255, 255, 255, 0.1)';
        ctx.fillRect(30, 80, 350, 480);
        ctx.fillStyle = 'rgba(255, 255, 255, 0.3)';
        ctx.font = 'bold 48px Arial';
        ctx.textAlign = 'center';
        ctx.fillText('🎫', 205, 340);
        ctx.textAlign = 'left';

        // Continue with text rendering
        this.renderTicketText(ctx, ticket, width, height);
      };
    },

    renderTicketText(ctx, ticket, width, height) {
      const leftMargin = 420;
      let currentY = 100;

      // Event Name
      ctx.fillStyle = '#ffffff';
      ctx.font = 'bold 32px Arial';
      const eventName = this.wrapText(ctx, ticket.event_name, width - leftMargin - 280, 32);
      eventName.forEach((line, index) => {
        ctx.fillText(line, leftMargin, currentY + (index * 38));
      });
      currentY += eventName.length * 38 + 10;

      // Separator line
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.3)';
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(leftMargin, currentY);
      ctx.lineTo(width - 40, currentY);
      ctx.stroke();
      currentY += 25;

      // Date & Time
      ctx.font = 'bold 20px Arial';
      ctx.fillStyle = 'rgba(255, 255, 255, 0.7)';
      ctx.fillText('📅 ' + this.formatDate(ticket.event_date), leftMargin, currentY);
      currentY += 30;
      ctx.fillText('🕐 ' + ticket.event_time_start, leftMargin, currentY);
      currentY += 40;

      // Location
      ctx.font = '18px Arial';
      ctx.fillStyle = 'rgba(255, 255, 255, 0.8)';
      ctx.fillText('📍 ' + ticket.event_location, leftMargin, currentY);
      currentY += 30;

      // Address (jeśli jest)
      if (ticket.event_location_address) {
        ctx.font = '14px Arial';
        ctx.fillStyle = 'rgba(255, 255, 255, 0.6)';
        const address = this.wrapText(ctx, ticket.event_location_address, width - leftMargin - 280, 14);
        address.forEach((line, index) => {
          ctx.fillText(line, leftMargin + 25, currentY + (index * 18));
        });
        currentY += address.length * 18 + 15;
      }

      // Separator
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.2)';
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(leftMargin, currentY);
      ctx.lineTo(width - 40, currentY);
      ctx.stroke();
      currentY += 20;

      // Ticket Details
      ctx.font = 'bold 16px Arial';
      ctx.fillStyle = 'rgba(255, 255, 255, 0.7)';
      ctx.fillText('Ticket Information', leftMargin, currentY);
      currentY += 25;

      ctx.font = '14px Arial';
      ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';

      // Ticket Type
      ctx.fillText('Type: ' + (ticket.ticket_type || 'Standard'), leftMargin, currentY);
      currentY += 22;

      // Category
      if (ticket.ticket_category) {
        ctx.fillText('Category: ' + ticket.ticket_category, leftMargin, currentY);
        currentY += 22;
      }

      // Seat Info
      if (ticket.ticket_section || ticket.ticket_row || ticket.ticket_seat) {
        let seatInfo = 'Seat: ';
        if (ticket.ticket_section) seatInfo += 'Section ' + ticket.ticket_section;
        if (ticket.ticket_row) seatInfo += ', Row ' + ticket.ticket_row;
        if (ticket.ticket_seat) seatInfo += ', Seat ' + ticket.ticket_seat;
        ctx.fillText(seatInfo, leftMargin, currentY);
        currentY += 22;
      }

      // Ticket Number
      ctx.fillStyle = 'rgba(255, 255, 255, 0.6)';
      ctx.font = '12px Arial';
      ctx.fillText('Ticket #' + ticket.ticket_number, leftMargin, currentY);
      currentY += 20;

      // Owner (jeśli nie-transferable)
      if (!ticket.is_transferable && (ticket.owner_name || ticket.owner_surname)) {
        ctx.fillText('Holder: ' + ticket.owner_name + ' ' + ticket.owner_surname, leftMargin, currentY);
        currentY += 20;
      }

      // QR Code (prawy dolny róg)
      const qrSize = 200;
      const qrX = width - qrSize - 40;
      const qrY = height - qrSize - 40;

      // QR Code background
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(qrX - 10, qrY - 10, qrSize + 20, qrSize + 20);

      // Generate QR Code
      this.generateQRForTicket(ticket, qrSize, (qrDataURL) => {
        const qrImg = new Image();
        qrImg.onload = () => {
          ctx.drawImage(qrImg, qrX, qrY, qrSize, qrSize);

          // QR Label
          ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
          ctx.font = 'bold 14px Arial';
          ctx.textAlign = 'center';
          ctx.fillText('SCAN TO VALIDATE', qrX + qrSize/2, qrY - 20);
          ctx.textAlign = 'left';

          // Footer
          const footerY = height - 25;
          ctx.fillStyle = 'rgba(255, 255, 255, 0.5)';
          ctx.font = '12px Arial';
          ctx.fillText('Powered by Muzible', 30, footerY);

          // Download
          this.downloadCanvasAsImage(ctx.canvas, ticket);
        };
        qrImg.src = qrDataURL;
      });
    },

    wrapText(ctx, text, maxWidth, fontSize) {
      const words = text.split(' ');
      const lines = [];
      let currentLine = words[0];

      for (let i = 1; i < words.length; i++) {
        const word = words[i];
        const width = ctx.measureText(currentLine + ' ' + word).width;
        if (width < maxWidth) {
          currentLine += ' ' + word;
        } else {
          lines.push(currentLine);
          currentLine = word;
        }
      }
      lines.push(currentLine);
      return lines;
    },

    generateQRForTicket(ticket, size, callback) {
      // Użyj istniejącego QR code z dialogu jeśli dostępny
      const existingQR = document.querySelector('.qr-code-card img');
      
      if (existingQR && existingQR.src && existingQR.src.startsWith('data:image/png')) {
        callback(existingQR.src);
        return;
      }

      // Użyj qrcode library bezpośrednio
      import('qrcode').then(QRCode => {
        // Utwórz canvas element
        const canvas = document.createElement('canvas');
        
        // Opcje QR code
        const options = {
          errorCorrectionLevel: 'H',
          type: 'image/png',
          quality: 1,
          margin: 1,
          width: size,
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          }
        };

        // Generuj QR code na canvas
        QRCode.default.toCanvas(canvas, ticket.qr_code, options, (error) => {
          if (error) {
            console.error('Error generating QR code:', error);
            // Fallback - użyj placeholder
            this.generatePlaceholderQR(size, callback);
            return;
          }
          
          // Konwertuj canvas do data URL
          const dataURL = canvas.toDataURL('image/png', 1.0);
          callback(dataURL);
        });

      }).catch(error => {
        // Fallback - użyj placeholder
        this.generatePlaceholderQR(size, callback);
      });
    },

    generatePlaceholderQR(size, callback) {
      // Generuje prosty placeholder jako Data URL
      const canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d');
      
      // Białe tło
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, size, size);
      
      // Czarny border
      ctx.strokeStyle = '#000000';
      ctx.lineWidth = 2;
      ctx.strokeRect(5, 5, size - 10, size - 10);
      
      // Text
      ctx.fillStyle = '#000000';
      ctx.font = 'bold 20px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText('QR CODE', size / 2, size / 2 - 10);
      ctx.font = '14px Arial';
      ctx.fillText('Not Available', size / 2, size / 2 + 15);
      
      callback(canvas.toDataURL('image/png'));
    },

    downloadCanvasAsImage(canvas, ticket) {
      try {
        // Konwertuj canvas do blob
        canvas.toBlob((blob) => {
          if (!blob) {
            this.notifyError('Failed to generate ticket image');
            return;
          }

          // Przygotuj nazwę pliku
          const eventName = ticket.event_name
            .replace(/[^a-z0-9]/gi, '_')
            .toLowerCase()
            .substring(0, 30);
          const fileName = `muzible_ticket_${eventName}_${ticket.ticket_number}.png`;

          // Sprawdź czy to mobile
          const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

          if (isMobileDevice && 'share' in navigator && navigator.canShare && navigator.canShare({ files: [new File([blob], fileName, { type: 'image/png' })] })) {
            // Mobile z Web Share API
            const file = new File([blob], fileName, { type: 'image/png' });
            
            navigator.share({
              title: `Ticket: ${ticket.event_name}`,
              text: `Ticket #${ticket.ticket_number}`,
              files: [file]
            }).then(() => {
              this.notify('Ticket image shared successfully!');
            }).catch((error) => {
              if (error.name !== 'AbortError') {
                this.downloadImageFallback(blob, fileName);
              }
            });
          } else {
            // Desktop - bezpośrednie pobieranie
            this.downloadImageFallback(blob, fileName);
          }
        }, 'image/png', 1.0);

      } catch (error) {
        this.notifyError('Failed to generate ticket image');
      }
    },

    downloadImageFallback(blob, fileName) {
      try {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => URL.revokeObjectURL(url), 100);
        this.notify('Ticket image downloaded successfully!');
      } catch (error) {
        this.notifyError('Failed to download ticket image');
      }
    },

    shareTicket(ticket) {
      this.selectedTicket = ticket;
      this.showShareDialog = true;
    },

    async shareToVerse(ticket, includeSeating) {
      try {
        // Przygotuj dane posta
        const postData = {
          type: 'ticket_share',
          event_name: ticket.event_name,
          event_date: ticket.event_date,
          event_time: ticket.event_time_start,
          event_location: ticket.event_location,
          event_image: ticket.event_image,
          ticket_type: ticket.ticket_type,
          event_link: `https://tickets.muzible.com/events/${ticket.event_id}`,
          include_seating: includeSeating,
          seating_info: includeSeating ? {
            section: ticket.ticket_section,
            row: ticket.ticket_row,
            seat: ticket.ticket_seat
          } : null
        };

        // Wyślij do Verse API
        const response = await this.$store.dispatch('shareTicketToVerse', {
          post_data: postData,
          token: this.user.token,
          verse_username: this.user.verse_username
        });

        if (response && response.success) {
          // Otwórz nowo utworzony post na Verse
          this.notify('Shared to Verse successfully!');
          this.showShareDialog = false;
        }
      } catch (error) {
        this.notifyError('Failed to share to Verse');
      }
    },

    shareToTwitter(ticket, includeSeating) {
      // Przygotuj tekst
      let text = `🎫 I'm attending ${ticket.event_name}!\n`;
      text += `📅 ${this.formatDate(ticket.event_date)} at ${ticket.event_time_start}\n`;
      text += `📍 ${ticket.event_location}\n`;
      
      if (includeSeating && (ticket.ticket_section || ticket.ticket_row || ticket.ticket_seat)) {
        text += `🪑 `;
        if (ticket.ticket_section) text += `Section ${ticket.ticket_section}`;
        if (ticket.ticket_row) text += `, Row ${ticket.ticket_row}`;
        if (ticket.ticket_seat) text += `, Seat ${ticket.ticket_seat}`;
        text += `\n`;
      }
      
      text += `\n🎵 Get your tickets at tickets.muzible.com`;
      
      // URL do wydarzenia
      const eventUrl = `https://tickets.muzible.com/events/${ticket.event_id}`;
      
      // Hashtags
      const hashtags = 'Muzible,LiveMusic,Concert';
      
      // Otwórz Twitter share
      const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(eventUrl)}&hashtags=${hashtags}`;
      window.open(twitterUrl, '_blank', 'width=550,height=420');
      
      this.notify('Opening Twitter...');
      this.showShareDialog = false;
    },

    shareToFacebook(ticket) {
      // Facebook przyjmuje tylko URL, nie można przekazać pre-filled text
      const eventUrl = `https://tickets.muzible.com/events/${ticket.event_id}`;
      
      const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(eventUrl)}`;
      window.open(facebookUrl, '_blank', 'width=550,height=420');
      
      this.notify('Opening Facebook...');
      this.showShareDialog = false;
    },

    async copyTicketLink(ticket) {
      const eventUrl = `https://tickets.muzible.com/events/${ticket.event_id}`;
      
      try {
        await navigator.clipboard.writeText(eventUrl);
        this.notify('Event link copied to clipboard!');
        this.showShareDialog = false;
      } catch (error) {
        // Fallback dla starszych przeglądarek
        const textArea = document.createElement('textarea');
        textArea.value = eventUrl;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        document.body.appendChild(textArea);
        textArea.select();
        
        try {
          document.execCommand('copy');
          this.notify('Event link copied to clipboard!');
          this.showShareDialog = false;
        } catch (err) {
          this.notifyError('Failed to copy link');
        }
        
        document.body.removeChild(textArea);
      }
    },

    async nativeShare(ticket, includeSeating) {
      if (!navigator.share) {
        this.notifyError('Share not supported on this device');
        return;
      }

      let text = `🎫 ${ticket.event_name}\n`;
      text += `📅 ${this.formatDate(ticket.event_date)} at ${ticket.event_time_start}\n`;
      text += `📍 ${ticket.event_location}`;
      
      if (includeSeating && (ticket.ticket_section || ticket.ticket_row || ticket.ticket_seat)) {
        text += `\n🪑 `;
        if (ticket.ticket_section) text += `Section ${ticket.ticket_section}`;
        if (ticket.ticket_row) text += `, Row ${ticket.ticket_row}`;
        if (ticket.ticket_seat) text += `, Seat ${ticket.ticket_seat}`;
      }

      const eventUrl = `https://tickets.muzible.com/events/${ticket.event_id}`;

      try {
        await navigator.share({
          title: ticket.event_name,
          text: text,
          url: eventUrl
        });
        
        this.notify('Shared successfully!');
        this.showShareDialog = false;
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.notifyError('Failed to share');
        }
      }
    },

    async shareWithImage(ticket, includeSeating) {
      // Generuj obrazek z informacjami o bilecie
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      // Rozmiar dla social media (1200x630 - optymalny dla FB/Twitter)
      const width = 1200;
      const height = 630;
      canvas.width = width;
      canvas.height = height;

      // Background
      const gradient = ctx.createLinearGradient(0, 0, width, height);
      gradient.addColorStop(0, '#1a1a1a');
      gradient.addColorStop(1, '#2d2d2d');
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, width, height);

      // Load event image
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.src = ticket.event_image;

      img.onload = () => {
        // Draw blurred background image
        ctx.save();
        ctx.filter = 'blur(20px) brightness(0.4)';
        ctx.drawImage(img, 0, 0, width, height);
        ctx.restore();

        // Draw event image in center
        const imgSize = 200;
        const imgX = (width - imgSize) / 2;
        const imgY = 80;
        
        ctx.save();
        ctx.beginPath();
        ctx.roundRect(imgX, imgY, imgSize, imgSize, 16);
        ctx.clip();
        ctx.drawImage(img, imgX, imgY, imgSize, imgSize);
        ctx.restore();

        // Event name
        ctx.fillStyle = '#ffffff';
        ctx.font = 'bold 48px Arial';
        ctx.textAlign = 'center';
        ctx.fillText(ticket.event_name, width / 2, imgY + imgSize + 60);

        // Date & Location
        ctx.font = '28px Arial';
        ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
        ctx.fillText(this.formatDate(ticket.event_date), width / 2, imgY + imgSize + 100);
        ctx.fillText(ticket.event_location, width / 2, imgY + imgSize + 135);

        // Seating info (if included)
        if (includeSeating && (ticket.ticket_section || ticket.ticket_row || ticket.ticket_seat)) {
          let seatText = '';
          if (ticket.ticket_section) seatText += `Section ${ticket.ticket_section}`;
          if (ticket.ticket_row) seatText += ` • Row ${ticket.ticket_row}`;
          if (ticket.ticket_seat) seatText += ` • Seat ${ticket.ticket_seat}`;
          
          ctx.font = '24px Arial';
          ctx.fillStyle = 'rgba(255, 255, 255, 0.7)';
          ctx.fillText(seatText, width / 2, imgY + imgSize + 170);
        }

        // Footer
        ctx.font = 'bold 20px Arial';
        ctx.fillStyle = 'rgba(255, 255, 255, 0.6)';
        ctx.fillText('tickets.muzible.com', width / 2, height - 40);

        // Convert to blob and share
        canvas.toBlob(async (blob) => {
          if (!blob) {
            this.notifyError('Failed to generate share image');
            return;
          }

          const file = new File([blob], `${ticket.event_name.replace(/[^a-z0-9]/gi, '_')}.png`, { type: 'image/png' });
          
          // Sprawdź czy Web Share API jest dostępne i obsługuje pliki
          const canShare = typeof navigator !== 'undefined' && 
                          'share' in navigator && 
                          typeof navigator.canShare === 'function' &&
                          navigator.canShare({ files: [file] });

          if (canShare) {
            try {
              await navigator.share({
                title: ticket.event_name,
                text: `🎫 I'm attending ${ticket.event_name}!`,
                files: [file]
              });
              this.notify('Shared successfully!');
              this.showShareDialog = false;
            } catch (error) {
              if (error.name !== 'AbortError') {
                // Fallback - download
                this.downloadImageFromBlob(blob, file.name);
              }
            }
          } else {
            // Fallback - download image
            this.downloadImageFromBlob(blob, file.name);
          }
        }, 'image/png', 1.0);
      };

      img.onerror = () => {
        this.notifyError('Failed to generate share image');
      };
    },

    downloadImageFromBlob(blob, fileName) {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      this.notify('Image downloaded! You can now share it manually.');
      this.showShareDialog = false;
    },

    openMap(ticket) {
      if (ticket.event_location_map_link) {
        window.open(ticket.event_location_map_link, '_blank');
      }
    },

    sellTicket(ticket) {
      this.notify('Sell ticket feature coming soon!');
      // TODO: Implement sell ticket modal
    },

    transferTicket(ticket) {
        this.selectedTicket = ticket;
        this.showTransferDialog = true;
        this.transferStep = 1;
        this.transferSearchQuery = '';
        this.transferSearchResults = [];
        this.selectedTransferRecipient = null;
        this.transferPassword = '';
        this.transferPasswordError = false;
        this.transferring = false;
        this.transferSuccess = false;
        if (this.transferSearchTimeout) {
          clearTimeout(this.transferSearchTimeout)
          this.transferSearchTimeout = null
        }
    },

      closeTransferDialog() {
        this.showTransferDialog = false;
        this.transferStep = 1;
        this.transferSearchQuery = '';
        this.transferSearchResults = [];
        this.selectedTransferRecipient = null;
        this.transferPassword = '';
        this.transferPasswordError = false;
        this.transferring = false;
        this.transferSuccess = false;
        if (this.transferSearchTimeout) {
          clearTimeout(this.transferSearchTimeout)
          this.transferSearchTimeout = null
        }
      },

      async searchUsersForTransfer() {
        // Wyczyść poprzedni timeout
        if (this.transferSearchTimeout) {
          clearTimeout(this.transferSearchTimeout);
        }

        const query = this.transferSearchQuery?.trim();

        // Minimum 3 znaki
        if (!query || query.length < 3) {
          this.transferSearchResults = [];
          return;
        }

        chatService.setToken(this.user.token);

        // Debounce - czekaj 300ms po ostatnim wpisie
        this.transferSearchTimeout = setTimeout(() => {
          this.searchingUsers = true;

          // Użyj chatService do wyszukania użytkowników
          chatService.usersSearch(query)
            .then(response => {
              if (response) {
                // Filtruj - nie pokazuj siebie
                this.transferSearchResults = response.filter(
                  user => user._id !== this.user.id && user.verse_username
                );
              } else {
                this.transferSearchResults = [];
              }
            })
            .catch(error => {
              this.notifyError('Failed to search users');
              this.transferSearchResults = [];
            })
            .finally(() => {
              this.searchingUsers = false;
            });
        }, 300);
      },

      selectTransferRecipient(user) {
        this.selectedTransferRecipient = user;
        this.transferStep = 2;
      },

      confirmTransfer() {
        if (!this.transferPassword || this.transferPassword.length === 0) {
          this.notifyError('Please enter your password');
          return;
        }

        if (!this.selectedTransferRecipient) {
          this.notifyError('No recipient selected');
          return;
        }

        this.transferring = true;
        this.transferPasswordError = false;
        this.transferStep = 3;

        this.$store.dispatch('transferTicket', {
          ticket_id: this.selectedTicket.id,
          recipientUserId: this.selectedTransferRecipient.id,
          pass: this.transferPassword,
          token: this.user.token
        })
          .then(response => {
            console.log('confirm Transfer ', response);
            if (response && response.data && response.data.success) {
              this.transferSuccess = true;
              this.notify('Ticket transferred successfully to @' + this.selectedTransferRecipient.verse_username);
              
              // Odśwież listę biletów po 2 sekundach
              setTimeout(() => {
                this.fetchTickets();
                this.closeTransferDialog();
              }, 2000);
            } else {
              this.notifyError('Failed to transfer ticket');
              this.transferSuccess = false;
            }
          })
          .catch(error => {            
            // Sprawdź czy błąd to invalid password
            if (error.response?.status === 401 || error.message?.includes('password')) {
              this.transferPasswordError = true;
              this.transferStep = 2;
              this.notifyError('Invalid password. Please try again.');
            } else {
              this.notifyError(error.message || 'Failed to transfer ticket');
              this.transferStep = 2;
            }
            
            this.transferSuccess = false;
          })
          .finally(() => {
            this.transferring = false;
          });
      },

    async refundTicket(ticket) {
      if (!ticket) {
      this.notifyError('No ticket selected');
      return;
      }
      if (!this.user) {
      this.notifyError('You must be logged in to request a refund');
      return;
      }
      try {
        await this.$store.dispatch('requestTicketRefundPolicy', {
          ticket_id: ticket.id,
          token: this.user.token
        });
        this.notify('Refund request submitted successfully!');
        } catch (error) {
        this.notifyError('Failed to submit refund request');
        }
    },


    playPromoTrack(ticket) {
      if (!ticket.promo_track_id) return;
       this.$store.dispatch('getTrackById', {
         track_id: ticket.promo_track_id,
         token: this.user.token
       }).then((track) => {
         // Play track in music player
         this.emitter.emit("playOrPauseSong", track.data.track);

         this.notify('Playing promo track!');
       }).catch(() => {
         this.notifyError('Failed to load promo track');
       });
    },

    goToEvents() {
      window.location.href = 'https://tickets.muzible.com/events/'
    },

    handleClickMenu(link){
      if (link === 'TryMuzE'){
        window.location.href = 'https://muze.muzible.com/';
      } else if (link === 'TryVerse'){
        window.location.href = 'https://verse.muzible.com/';
      } else {
        if (this.$route.name !== link ) {
          this.$router.push({ name: link });
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

@use './css/styles.scss';

@keyframes blink {
  0% {
    opacity: 1;
  }
  40% {
    opacity: 1;
  }
  60% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}

.blink {
      -webkit-animation: blink 1.5s infinite both;
            animation: blink 1.5s infinite both;
}

/* Tickets Header */
.tickets-header {
  margin-bottom: 24px;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.header-icon {
  font-size: 48px !important;
  color: white;
}

.header-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 42px;
  font-weight: 700;
  color: white;
  margin: 0;
}

.tickets-count {
  background: rgba(255, 255, 255, 0.1);
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 14px;
  color: white;
  font-weight: 500;
}

.filters-section {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.filter-toggle {
  color: rgba(128, 128, 128, 0.482);
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
}

/* Empty State */
.empty-state {
  min-height: 400px;
  padding: 60px 20px;
}

.empty-icon-wrapper {
  margin-bottom: 24px;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
}

.empty-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 32px;
  font-weight: 600;
  color: white;
  margin-bottom: 8px;
}

.empty-subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 24px;
}

/* Tickets Grid */
.tickets-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 24px;
  padding: 8px 0;
}

@media (max-width: 768px) {
  .tickets-grid {
    grid-template-columns: 1fr;
  }
}

/* Ticket Card */
.ticket-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.95), rgba(18, 18, 18, 0.95));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
}

.ticket-card:hover {
  transform: translateY(-4px);
  border-color: rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.4);
}

.ticket-card.ticket-nft {
  border: 1px solid rgba(98, 126, 234, 0.3);
}

.ticket-card.ticket-nft:hover {
  border-color: rgba(98, 126, 234, 0.6);
  box-shadow: 0 8px 16px rgba(98, 126, 234, 0.2);
}

.ticket-card.ticket-used {
  opacity: 1;
  filter: grayscale(0.7);
}

/* Ticket Image */
.ticket-image-container {
  position: relative;
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.ticket-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.ticket-card:hover .ticket-image {
  transform: scale(1.05);
}

.ticket-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.8) 100%);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 12px;
}

.current-listing {
  padding: 8px;
  border-radius: 8px;
}

.listing-header {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  color: white;
}

.resale-history {
  margin-top: 16px;
}
.resale-details {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
}

.resale-detail-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
}

.resale-number {
  font-size: 13px;
  font-weight: 500;
  color: white;
}

.resale-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.subsection-title {
  font-size: 14px;
  font-weight: 600;
  color: white;
  margin-bottom: 12px;
}

.resale-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.resale-item {
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 12px;
  background: rgba(255, 255, 255, 0.05);
}

.listing-title {
  font-size: 14px;
  font-weight: 700;
}

.ticket-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.badge-nft {
  background: linear-gradient(135deg, #627eea 0%, #4a5fc1 100%);
  color: white;
}

.badge-type {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  backdrop-filter: blur(10px);
}

.badge-used {
  background: rgba(158, 158, 158, 0.9);
  color: white;
}

.badge-expired {
  background: rgba(211, 47, 47, 0.9);
  color: white;
}

.badge-for-sale {
  background: rgba(255, 193, 7, 0.9);
  color: white;
}

.badge-active {
  background: rgba(76, 175, 80, 0.9);
  color: white;
}

.view-details-btn {
  background: rgba(255, 255, 255, 0.2) !important;
  backdrop-filter: blur(10px);
}

/* Ticket Content */
.ticket-content {
  padding: 20px;
}

.ticket-event-info {
  margin-bottom: 16px;
}

.event-name {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: white;
  margin-bottom: 6px;
  line-height: 1.2;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.event-location {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  gap: 4px;
}

.ticket-datetime {
  display: flex;
  gap: 16px;
  margin-bottom: 12px;
  padding: 10px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
}

.datetime-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
}

.ticket-seat-info {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
}

.seat-item {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
}

.ticket-perks {
  margin-bottom: 12px;
}

.perks-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 8px;
  font-weight: 500;
}

.perks-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.perk-chip {
  font-size: 11px !important;
}

.more-perks {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
  font-style: italic;
}

.ticket-price {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}

.price-label {
  color: rgba(255, 255, 255, 0.6);
}

.price-value {
  color: white;
  font-weight: 700;
  font-size: 18px;
}

.ticket-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.action-btn {
  flex: 1;
  min-width: 100px;
  font-size: 12px !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
}

.action-btn:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

/* Ticket Menu */
.ticket-menu {
  color: white;
  background: #1a1a1a !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

/* QR Dialog */
.qr-dialog {
  background: #121212 !important;
  color: white !important;
}

.qr-dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 20px !important;
}

.qr-dialog-content {
  padding: 32px !important;
}

.qr-code-container {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.qr-code-card {
  background: transparent;
  padding: 16px;
  border-radius: 12px;
  border: 0px solid transparent;
  box-shadow: none;
}

.qr-placeholder {
  background: rgba(255, 255, 255, 0.05);
  padding: 24px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.qr-code-text {
  font-family: monospace;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.7);
  word-break: break-all;
  text-align: center;
  max-width: 250px;
}

.qr-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: rgba(255, 255, 255, 0.05);
  padding: 16px;
  border-radius: 8px;
}

.qr-info-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
}

.qr-dialog-actions {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 16px 20px !important;
}

/* Details Dialog */
.details-dialog {
  background: #121212 !important;
  color: white !important;
  max-height: 90dvh!important;
}

.details-dialog-header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 24px !important;
}

.details-header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}

.details-header-content h2 {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 28px;
  font-weight: 700;
  margin: 0;
}

.ticket-number {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 4px;
}

.details-dialog-content {
  padding: 24px !important;
}

.details-section {
  margin-bottom: 32px;
}

.section-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: white;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

@media (max-width: 600px) {
  .info-grid {
    grid-template-columns: 1fr;
  }
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-item.full-width {
  grid-column: 1 / -1;
}

.info-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-value {
  font-size: 15px;
  color: white;
  font-weight: 500;
}

.info-value.monospace {
  font-family: 'Courier New', monospace;
  font-size: 12px;
  word-break: break-all;
}

.perks-detailed-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.perk-detailed-item {
  background: rgba(255, 255, 255, 0.05);
  padding: 16px;
  border-radius: 8px;
  border-left: 3px solid rgba(255, 255, 255, 0.3);
}

.perk-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.perk-name {
  font-weight: 600;
  font-size: 15px;
  flex: 1;
}

.perk-description {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 8px;
}

.perk-validity {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
}

.details-dialog-actions {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 16px 24px !important;
}

/* Animations */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.ticket-card {
  animation: slideIn 0.4s ease forwards;
}

.ticket-card:nth-child(1) { animation-delay: 0.05s; }
.ticket-card:nth-child(2) { animation-delay: 0.1s; }
.ticket-card:nth-child(3) { animation-delay: 0.15s; }
.ticket-card:nth-child(4) { animation-delay: 0.2s; }
.ticket-card:nth-child(5) { animation-delay: 0.25s; }
.ticket-card:nth-child(6) { animation-delay: 0.3s; }

/* Override existing styles if needed */
:deep(.v-btn:hover) > .v-btn__overlay {
  --v-hover-opacity: 0.1;
  opacity: 0.1;
}

:deep(.v-list-item:hover) > .v-list-item__overlay {
  --v-hover-opacity: 0.1;
  opacity: 0.1;
}


:deep(.v-btn[aria-haspopup=menu][aria-expanded=true])>.v-btn__overlay {
  --v-hover-opacity: 0.1;
  opacity: 0.1;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true]:hover)>.v-btn__overlay {
  --v-hover-opacity: 0.1;
  opacity: 0.1;
}

:deep(.v-list-item:hover)>.v-list-item__overlay {
  --v-hover-opacity: 0.1;
  opacity: 0.1;
}

:deep(.v-list-item__append){
  display: inline-block;
}

.legal-link {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: underline;
  cursor: pointer;
  font-size: 12px;
}

/* Owner Info */
.ticket-owner-info {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
  margin-bottom: 12px;
  font-size: 13px;
}

.owner-label {
  color: rgba(255, 255, 255, 0.6);
}

.owner-name {
  color: white;
  font-weight: 600;
}

/* Organizer Info in event location */
.event-organizer {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
}

/* Validation Info */
.ticket-validation-info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: rgba(76, 175, 80, 0.1);
  border: 1px solid rgba(76, 175, 80, 0.3);
  border-radius: 6px;
  margin-bottom: 12px;
}

.validation-text {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.9);
}

/* Cancelled Alert in Card */
.cancelled-alert {
  margin: 12px 0 !important;
  padding: 8px 12px !important;
}

.cancelled-info {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
}

.cancelled-date {
  margin-left: auto;
  font-size: 11px;
  opacity: 0.8;
}

.cancelled-reason {
  margin: 4px 0 0 0;
  font-size: 12px;
  opacity: 0.9;
}

/* Cancelled Badge */
.badge-cancelled {
  background: rgba(211, 47, 47, 0.9);
  color: white;
}

/* Refunded Badge */
.badge-refunded {
  background: rgba(255, 152, 0, 0.9);
  color: white;
}

/* Cancelled/Refunded Card Styles */
.ticket-card.ticket-cancelled {
  border-color: rgba(211, 47, 47, 0.3);
}

.ticket-card.ticket-refunded {
  border-color: rgba(255, 152, 0, 0.3);
}

/* Promo Track Section */
.promo-track-section {
  margin-bottom: 12px;
}

.promo-track-btn {
  width: 100%;
  border-color: rgba(76, 175, 80, 0.5) !important;
  color: rgb(76, 175, 80) !important;
}

.promo-track-btn:hover {
  background: rgba(76, 175, 80, 0.1) !important;
  border-color: rgba(76, 175, 80, 0.8) !important;
}

/* Refund Action Button */
.action-btn-refund {
  border-color: rgba(255, 152, 0, 0.5) !important;
  color: rgb(255, 152, 0) !important;
}

.action-btn-refund:hover {
  background: rgba(255, 152, 0, 0.1) !important;
  border-color: rgba(255, 152, 0, 0.8) !important;
}

/* QR Dialog Alert */
.alert-content {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.alert-title {
  font-weight: 600;
  margin-bottom: 4px;
}

.alert-details {
  font-size: 13px;
  opacity: 0.9;
}

/* Validation History */
.validation-history {
  background: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
  padding: 16px;
}

.validation-summary {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  font-weight: 600;
}

.validation-max {
  margin-left: auto;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 400;
}

.validation-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.validation-item {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
  padding: 12px;
}

.validation-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.validation-number {
  font-weight: 600;
  flex: 1;
}

.validation-details {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-left: 24px;
}

.validation-detail-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
}

/* Cancellation Alert in Details */
.cancellation-alert {
  margin: 0 !important;
}

/* Transfer History */
.transfer-info {
  background: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
  padding: 16px;
}

.transfer-summary {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  font-weight: 600;
}

.transfer-max {
  margin-left: auto;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 400;
}

.transfer-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.transfer-item {
  display: flex;
  gap: 12px;
}

.transfer-icon-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 4px;
}

.transfer-line {
  width: 2px;
  flex: 1;
  background: rgba(255, 255, 255, 0.2);
  margin: 8px 0;
}

.transfer-details {
  flex: 1;
  padding-bottom: 16px;
}

.transfer-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.transfer-label {
  font-weight: 600;
  flex: 1;
}

.transfer-info-grid {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.transfer-detail-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
}

/* Perk Quantity */
.perk-quantity {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 4px;
}

/* Perk Used Date */
.perk-used-date {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: rgba(158, 158, 158, 0.8);
  margin-top: 4px;
}

.language-display {
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
}
.flag-emoji {
  font-size: 16px;
}

/* Share Dialog */
.share-dialog {
  background: #121212 !important;
  color: white !important;
}

.share-dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 20px !important;
}

.share-dialog-content {
  padding: 24px !important;
}

.share-preview {
  display: flex;
  gap: 16px;
  align-items: center;
}

.share-preview-image {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 8px;
}

.share-preview-info h3 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
}

.share-preview-info p {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 4px;
}

.share-checkbox {
  margin-bottom: 0;
}

.checkbox-label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: white!important;
}

.seating-preview {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.6);
}

.share-options-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
}

.share-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.share-option-btn {
  justify-content: flex-start !important;
  text-transform: none !important;
  font-size: 15px !important;
}

.verse-btn {
  border-color: rgba(156, 39, 176, 0.5) !important;
  color: rgb(206, 147, 216) !important;
}

.verse-btn:hover {
  background: rgba(156, 39, 176, 0.1) !important;
  border-color: rgba(156, 39, 176, 0.8) !important;
}

.twitter-btn {
  border-color: rgba(29, 155, 240, 0.5) !important;
  color: rgb(29, 155, 240) !important;
}

.twitter-btn:hover {
  background: rgba(29, 155, 240, 0.1) !important;
  border-color: rgba(29, 155, 240, 0.8) !important;
}

.facebook-btn {
  border-color: rgba(66, 103, 178, 0.5) !important;
  color: rgb(66, 103, 178) !important;
}

.facebook-btn:hover {
  background: rgba(66, 103, 178, 0.1) !important;
  border-color: rgba(66, 103, 178, 0.8) !important;
}

.share-note {
  margin: 0 !important;
}

.share-note-content {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
}

/* Search Section */
.search-section {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.search-field {
  max-width: 600px;
}

.search-field :deep(.v-field) {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
}

.search-field :deep(.v-field__outline) {
  color: rgba(255, 255, 255, 0.2);
}

.search-field :deep(.v-field--focused .v-field__outline) {
  color: rgba(255, 255, 255, 0.5);
}

.search-field :deep(.v-field__input) {
  color: white;
  font-size: 14px;
}

.search-field :deep(.v-field__input::placeholder) {
  color: rgba(255, 255, 255, 0.5);
  opacity: 1;
}

.search-field :deep(.v-icon) {
  color: rgba(255, 255, 255, 0.6);
}

.search-results-info {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  padding: 4px 8px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
  width: fit-content;
}

@media (max-width: 768px) {
  .search-field {
    max-width: 100%;
  }
}

/* Empty State with Search */
.empty-state .empty-subtitle {
  max-width: 500px;
  margin: 0 auto 24px;
}

/* Load Older Section */
.load-older-section {
  margin-top: 28px;
  padding: 20px 20px;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 16px;
}

.load-older-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 20px;
}

.oldest-date-text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
}

.load-older-btn {
  max-width: 600px;
  margin: 0 auto 20px;
  font-size: 16px !important;
  font-weight: 600 !important;
  padding: 24px !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
  transition: all 0.3s ease;
}

.load-older-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.load-older-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination-info-footer {
  display: flex;
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap;
  margin-top: 16px;
}

.info-text {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
}

/* All Loaded Section */
.all-loaded-section {
  margin-top: 12px;
  padding: 20px 20px;
}

.all-loaded-message {
  text-align: center;
  padding: 20px 20px;
}

.all-loaded-message h3 {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: white;
  margin: 16px 0 8px;
}

.all-loaded-message p {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
}

/* Loading State */
.load-older-btn .v-progress-circular {
  margin: 0 8px;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .load-older-section {
    padding: 24px 16px;
  }

  .pagination-info-footer {
    flex-direction: column;
    gap: 8px;
  }

  .load-older-btn {
    font-size: 14px !important;
    padding: 20px !important;
  }
}

/* Animation for Load Older Button */
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

.load-older-btn:not(:disabled):hover {
  animation: pulse 2s ease-in-out infinite;
}

/* Loading Spinner Override */
:deep(.v-btn--loading) {
  pointer-events: none;
}

:deep(.v-btn--loading .v-btn__content) {
  opacity: 0.6;
}

/* Refund Pending Badge */
.badge-refund-pending {
  background: rgba(255, 152, 0, 0.9);
  color: white;
  animation: pulse-badge 2s ease-in-out infinite;
}

@keyframes pulse-badge {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

/* Refund Rejected Badge */
.badge-refund-rejected {
  background: rgba(211, 47, 47, 0.9);
  color: white;
}

/* Refund Pending Alert in Card */
.refund-pending-alert {
  margin: 12px 0 !important;
  padding: 12px !important;
}

.refund-pending-info {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.refund-pending-content {
  flex: 1;
}

.refund-pending-title {
  font-weight: 600;
  font-size: 13px;
  display: block;
  margin-bottom: 4px;
}

.refund-pending-text {
  font-size: 12px;
  margin: 0;
  opacity: 0.9;
}

/* Refund Rejected Alert in Card */
.refund-rejected-alert {
  margin: 12px 0 !important;
  padding: 12px !important;
}

.refund-rejected-info {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.refund-rejected-content {
  flex: 1;
}

.refund-rejected-title {
  font-weight: 600;
  font-size: 13px;
  display: block;
  margin-bottom: 4px;
}

.refund-rejected-reason {
  font-size: 12px;
  margin: 4px 0 0 0;
  opacity: 0.9;
}

/* Refund Button States */
.action-btn-refund-pending {
  border-color: rgba(255, 152, 0, 0.5) !important;
  color: rgba(255, 152, 0, 0.7) !important;
  cursor: not-allowed !important;
}

.action-btn-refund-pending:hover {
  background: transparent !important;
  border-color: rgba(255, 152, 0, 0.5) !important;
}

/* Refund Status Alert in Details */
.refund-status-alert {
  margin: 0 !important;
}

.refund-status-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.refund-status-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.refund-status-title {
  font-weight: 600;
  font-size: 16px;
}

.refund-status-text {
  margin: 0;
  font-size: 14px;
  opacity: 0.9;
}

/* Refund Timeline */
.refund-status-timeline {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
}

.timeline-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  flex: 1;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
}

.timeline-item.completed {
  color: rgba(76, 175, 80, 1);
}

.timeline-item.active {
  color: rgba(255, 152, 0, 1);
  font-weight: 600;
}

.refund-status-note {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  opacity: 0.7;
  margin: 0;
}

/* Refund Rejected Reason Box */
.refund-rejected-reason-box {
  background: rgba(0, 0, 0, 0.2);
  padding: 12px;
  border-radius: 6px;
  border-left: 3px solid rgba(211, 47, 47, 0.8);
}

.refund-rejected-reason-box strong {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
}

.refund-rejected-reason-box p {
  margin: 0;
  font-size: 13px;
  opacity: 0.9;
}

/* Contact Support Buttons */
.refund-contact-support {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

@media (max-width: 600px) {
  .refund-contact-support {
    flex-direction: column;
  }
  
  .refund-contact-support .v-btn {
    width: 100%;
  }
}

/* Transfer Dialog */
.transfer-dialog {
  background: #121212 !important;
  color: white !important;
}

.transfer-dialog-header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 20px !important;
}

.transfer-header-content {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 20px;
  font-weight: 600;
}

.transfer-dialog-content {
  padding: 24px !important;
}

/* Ticket Preview */
.transfer-ticket-preview {
  display: flex;
  gap: 16px;
  align-items: center;
  padding: 16px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
}

.transfer-ticket-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 6px;
}

.transfer-ticket-info {
  flex: 1;
}

.transfer-ticket-info h3 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 6px;
}

.transfer-ticket-info p {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 2px;
}

/* Transfer Steps */
.transfer-steps {
  min-height: 300px;
}

.transfer-step {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.step-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}

/* Search Field */
.transfer-search-field :deep(.v-field) {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
}

.transfer-search-field :deep(.v-field__input) {
  color: white;
}

/* Search Results */
.transfer-search-results {
  margin-top: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  overflow: hidden;
}

.search-results-header {
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.05);
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.transfer-users-list {
  background: transparent !important;
  max-height: 300px;
  overflow-y: auto;
}

.transfer-user-item {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  cursor: pointer;
  transition: background 0.2s;
  color: white!important;
}

.transfer-user-item:hover {
  background: rgba(255, 255, 255, 0.05) !important;
}

.transfer-user-item:last-child {
  border-bottom: none;
}

.avatar-text {
  font-weight: 600;
  font-size: 18px;
}

/* No Results */
.transfer-no-results {
  text-align: center;
  padding: 40px 20px;
  color: rgba(255, 255, 255, 0.5);
}

.transfer-no-results p {
  margin-top: 12px;
  font-size: 14px;
}

/* Search Hint */
.search-hint {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
}

/* Recipient Card */
.transfer-recipient-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 16px;
}

.recipient-header {
  margin-bottom: 12px;
}

.recipient-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.recipient-info {
  display: flex;
  align-items: center;
  align-content: center;
  gap: 12px;
}

.recipient-details {
  flex: 1;
}

.recipient-username {
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}

.recipient-display-name {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 2px;
}

/* Transfer Warning */
.transfer-warning {
  margin: 0 !important;
}

.warning-content {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.warning-title {
  font-weight: 600;
  margin-bottom: 8px;
}

.warning-list {
  margin: 0;
  padding-left: 20px;
  font-size: 13px;
}

.warning-list li {
  margin-bottom: 4px;
}

/* Password Confirmation */
.password-confirmation {
  margin-top: 24px;
}

.confirmation-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 12px;
  color: rgba(255, 255, 255, 0.9);
}

.password-field :deep(.v-field) {
  background: rgba(255, 255, 255, 0.05);
}

.password-field :deep(.v-field__input) {
  color: white;
}

/* Processing/Success States */
.transfer-processing,
.transfer-success {
  text-align: center;
  padding: 40px 20px;
}

.transfer-processing h4,
.transfer-success h4 {
  font-size: 20px;
  font-weight: 600;
  margin: 16px 0 8px;
}

.transfer-processing p,
.transfer-success p {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
}

/* Dialog Actions */
.transfer-dialog-actions {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 16px 24px !important;
}

/* Scrollbar for search results */
.transfer-users-list::-webkit-scrollbar {
  width: 6px;
}

.transfer-users-list::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
}

.transfer-users-list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.transfer-users-list::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* Mobile Responsive */
@media (max-width: 600px) {
  .transfer-ticket-preview {
    flex-direction: column;
    text-align: center;
  }

  .transfer-ticket-image {
    width: 120px;
    height: 120px;
  }

  .recipient-info {
    flex-direction: column;
    align-items: flex-start;
  }
}

.user-status {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #dc3545;
  transition: color 0.3s ease;
}

.user-status.online {
  color: #28a745;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #dc3545;
  animation: pulse 2s ease-in-out infinite;
}

.status-dot.online {
  background: #28a745;
}

</style>
